'use strict';

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var dateFns = require('date-fns');
var classnames = require('classnames');
var cauldronReact = require('@deque/cauldron-react');
var accessibilityStandards = require('@deque/accessibility-standards');
var reactI18next = require('react-i18next');
var i18n = require('i18next');
var utils = require('@react-aria/utils');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var classnames__default = /*#__PURE__*/_interopDefault(classnames);
var i18n__default = /*#__PURE__*/_interopDefault(i18n);

var isCheckpointTagInfo$1 = function (tagInfo) {
    return 'checkpoint' in tagInfo && !!tagInfo.checkpoint;
};
var isWCAGCheckpoint = function (tagInfo) {
    return isCheckpointTagInfo$1(tagInfo) && tagInfo.standard === 'WCAG';
};
/**
 * Screenshot configuration is used to indicate the state of the current
 * screenshot configuration via org-wide settings and what the configuration
 * was at the time the issue was captured. Each of the specified states
 * names always specifies what the current state is, and how that value
 * is relative to the historical org-wide settings with regards to screenshots.
 */
var ScreenshotConfiguration = {
    /**
     * When both the current screenshot configuration, and the screenshot
     * configuration at the time the issue was created was both "on"
     */
    On: 'on',
    /**
     * When the current screenshot configuration is "on", and the screenshot
     * configuration at the time the issue was created was "off"
     */
    MixedOn: 'mixed-on',
    /**
     * When the current screenshot configuration is "off", and the screenshot
     * configuration at the time the issue was created was "on"
     */
    MixedOff: 'mixed-off',
    /**
     * When both the current screenshot configuration, and the screenshot
     * configuration at the time the issue was created was both "off" and the
     * the user is allowed to change the value
     */
    Off: 'off',
    /**
     * When both the current screenshot configuration, and the screenshot
     * configuration at the time the issue was created was both "off" and the
     * the user is not allowed to change the value
     */
    OffLocked: 'off-locked'
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var isCheckpointTagInfo = function (tagInfo) {
    return 'checkpoint' in tagInfo && !!tagInfo.checkpoint;
};
var getCheckpoints = function (tags) {
    var e_1, _a;
    if (!Array.isArray(tags)) {
        return [];
    }
    var checkpoints = [];
    try {
        for (var tags_1 = __values(tags), tags_1_1 = tags_1.next(); !tags_1_1.done; tags_1_1 = tags_1.next()) {
            var tag = tags_1_1.value;
            var tagInfo = accessibilityStandards.getTagInfo(tag);
            if (tagInfo && isCheckpointTagInfo(tagInfo)) {
                checkpoints.push(tagInfo);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tags_1_1 && !tags_1_1.done && (_a = tags_1.return)) _a.call(tags_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return checkpoints;
};
/**
 * Returns a list of all matching  checkpoint tags with tag info from a list of axe-core tags.
 *
 * @example
 * const checkpointsTagInfo = useCheckpointsTagInfo(['cat.color', 'wcag21aa', 'wcag143', 'en-301-549'])
 */
function useCheckpointsTagInfo(tags) {
    return React.useMemo(function () { return getCheckpoints(tags); }, [JSON.stringify(tags)]);
}

var isRulesetTag$1 = function (tag) { return tag in accessibilityStandards.rulesets; };
/**
 * Returns array of accessibility standards from a list of tags
 *
 *
 * example: const standardTags = useAccessibilityStandards(['foo', 'bar', 'wcag142', 'EN-301-549', 'TTv5', 'wcag2a']);
 * returns
 * [
      { value: 'EN-301-549', name: 'EN 301 549', tags: [ 'EN-301-549' ] },
      { value: 'TTv5', name: 'Trusted Tester v5', tags: [ 'TTv5' ] },
      { value: 'wcag2a', name: 'WCAG 2.0 A', tags: [ 'wcag2a' ] }
    ]
 */
function useAccessibilityStandards(tags) {
    return React.useMemo(function () {
        var e_1, _a;
        if (!Array.isArray(tags)) {
            return [];
        }
        var standards = [];
        try {
            for (var tags_1 = __values(tags), tags_1_1 = tags_1.next(); !tags_1_1.done; tags_1_1 = tags_1.next()) {
                var tag = tags_1_1.value;
                var tagInfo = accessibilityStandards.getTagInfo(tag);
                if ((tagInfo === null || tagInfo === void 0 ? void 0 : tagInfo.standard) && isRulesetTag$1(tag)) {
                    standards.push(accessibilityStandards.rulesets[tag]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (tags_1_1 && !tags_1_1.done && (_a = tags_1.return)) _a.call(tags_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return standards;
    }, [JSON.stringify(tags)]);
}

var instance = i18n__default.default.createInstance({
    lng: 'en-US',
    fallbackLng: 'en-US',
    debug: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',
    ns: ['launchpad'],
    defaultNS: 'launchpad',
    interpolation: {
        escapeValue: false // react is already xss-safe
    },
    nsSeparator: false,
    keySeparator: false
});
instance.init();

// The below functions are mirroring the exported Trans and useTranslation functions
// from react-i18next in order to set the default namespace and i18n instance
function Trans(_a) {
    var _b = _a.ns, ns = _b === void 0 ? 'launchpad' : _b, props = __rest(_a, ["ns"]);
    return jsxRuntime.jsx(reactI18next.Trans, __assign({ ns: ns, i18n: instance }, props));
}
function useTranslation() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = __read(args, 2), _b = _a[0], ns = _b === void 0 ? 'launchpad' : _b, options = _a[1];
    return reactI18next.useTranslation(ns, __assign({ i18n: instance }, options));
}

var modules_e80d9c32 = {"IssueMetadata":"_IssueMetadata_eef55444","IssueMetadata__tags":"_IssueMetadata__tags_eef55444","IssueMetadata__standardsList":"_IssueMetadata__standardsList_eef55444"};

var IssueMetadata = React.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e;
    var issue = _a.issue, className = _a.className, props = __rest(_a, ["issue", "className"]);
    var isManual = issue.isManual, igt = issue.igt, createdAt = issue.createdAt, metadata = issue.metadata, _f = issue.tags, allTags = _f === void 0 ? [] : _f, _g = issue.userTags, userTags = _g === void 0 ? [] : _g;
    var t = useTranslation().t;
    var discoveryMethod = React.useMemo(function () {
        if (isManual) {
            return t('Manual');
        }
        if (igt) {
            return "".concat(igt, " Intelligent Guided Test (IGT)");
        }
        return t('Automatic');
    }, [isManual, igt, t]);
    var standards = useAccessibilityStandards(allTags);
    var checkpoints = useCheckpointsTagInfo(allTags);
    var getStandardName = function (checkpoint) {
        var _a;
        // Section 508 isn't included in accessibility standards, but we continue to show it here
        if (checkpoint.standard === 'Section 508') {
            return 'Section 508';
        }
        return ((_a = standards.find(function (s) { return s.type === checkpoint.standard; })) === null || _a === void 0 ? void 0 : _a.name) || '';
    };
    var checkpointsWithStandard = React.useMemo(function () {
        return checkpoints
            .map(function (checkpoint) { return (__assign(__assign({}, checkpoint), { standardName: getStandardName(checkpoint) })); })
            .sort(function (a, b) {
            var asn = a.standardName;
            var bsn = b.standardName;
            return asn.localeCompare(bsn);
        });
    }, [checkpoints, standards]);
    var nonCategorizedTags = React.useMemo(function () {
        var e_1, _a;
        var _tags = __spreadArray([], __read(userTags), false);
        try {
            for (var allTags_1 = __values(allTags), allTags_1_1 = allTags_1.next(); !allTags_1_1.done; allTags_1_1 = allTags_1.next()) {
                var tag = allTags_1_1.value;
                if (!accessibilityStandards.getTagInfo(tag)) {
                    // tag info implies it's a standard or checkpoint tag and can exclude it
                    _tags.push(tag);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (allTags_1_1 && !allTags_1_1.done && (_a = allTags_1.return)) _a.call(allTags_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _tags;
    }, [JSON.stringify(allTags), JSON.stringify(userTags)]);
    var renderStandardTag = function (tagInfo) {
        var standardName = tagInfo.standardName;
        var isWCAG = isWCAGCheckpoint(tagInfo);
        if (isWCAG) {
            return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [standardName || tagInfo.standard, ": ", tagInfo.checkpoint, ' ', tagInfo.checkpointDescription] }));
        }
        return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [standardName, " ", tagInfo.checkpoint] }));
    };
    return (jsxRuntime.jsx("div", __assign({ className: classnames__default.default(modules_e80d9c32.IssueMetadata, className), ref: ref }, props, { children: jsxRuntime.jsxs("dl", { className: modules_e80d9c32.IssueMetadata__list, children: [createdAt && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Date discovered') }), jsxRuntime.jsx("dd", { children: dateFns.format(new Date(createdAt), 'MMMM d, yyyy h:mm a') })] })), jsxRuntime.jsx("dt", { children: t('Discovery method') }), jsxRuntime.jsx("dd", { children: discoveryMethod }), ((_b = metadata === null || metadata === void 0 ? void 0 : metadata.platform) === null || _b === void 0 ? void 0 : _b.name) && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Platform') }), jsxRuntime.jsxs("dd", { children: [metadata.platform.name, " ", metadata.platform.version] })] })), ((_c = metadata === null || metadata === void 0 ? void 0 : metadata.device) === null || _c === void 0 ? void 0 : _c.name) && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Device') }), jsxRuntime.jsxs("dd", { children: [metadata.device.name, " ", metadata.device.version] })] })), ((_d = metadata === null || metadata === void 0 ? void 0 : metadata.browser) === null || _d === void 0 ? void 0 : _d.name) && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Browser') }), jsxRuntime.jsxs("dd", { children: [metadata.browser.name, " ", metadata.browser.version] })] })), (metadata === null || metadata === void 0 ? void 0 : metadata.viewport) &&
                    metadata.viewport.width &&
                    metadata.viewport.height && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Viewport Size') }), jsxRuntime.jsx("dd", { children: t('{{width}} by {{height}}', {
                                width: metadata.viewport.width,
                                height: metadata.viewport.height
                            }) })] })), ((_e = metadata === null || metadata === void 0 ? void 0 : metadata.viewport) === null || _e === void 0 ? void 0 : _e.devicePixelRatio) && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Device pixel ratio (DPR)') }), jsxRuntime.jsx("dd", { children: metadata.viewport.devicePixelRatio })] })), checkpointsWithStandard.length > 0 && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('All standards') }), jsxRuntime.jsx("dd", { children: checkpointsWithStandard.length === 1 ? (jsxRuntime.jsx(jsxRuntime.Fragment, { children: renderStandardTag(checkpointsWithStandard[0]) })) : (jsxRuntime.jsx("ul", { className: modules_e80d9c32.IssueMetadata__standardsList, children: checkpointsWithStandard.map(function (tagInfo) { return (jsxRuntime.jsx("li", { children: renderStandardTag(tagInfo) }, tagInfo.value)); }) })) })] })), nonCategorizedTags.length > 0 && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("dt", { children: t('Tags') }), jsxRuntime.jsx("dd", { className: modules_e80d9c32.IssueMetadata__tags, children: nonCategorizedTags.map(function (tag) { return (jsxRuntime.jsx(cauldronReact.Tag, { children: jsxRuntime.jsx(cauldronReact.TagLabel, { children: tag }) }, tag)); }) })] }))] }) })));
});
IssueMetadata.displayName = 'IssueMetadata';

var supportedLocales = [];

var defaultConfiguration = {
    screenshots: false,
    integrations: false
};
exports.ConfigurationContext = React.createContext(defaultConfiguration);
function configure(options) {
    exports.ConfigurationContext = React.createContext(__assign(__assign({}, defaultConfiguration), options));
}
var useConfiguration = function () {
    return __assign(__assign({}, defaultConfiguration), React.useContext(exports.ConfigurationContext));
};

/**
 * When a component needs to track an element's resize, useResizeObserver
 * via a ref or callback function will track the first resize entry invoking
 * the callback function and/or setting the value of the returned ref.
 *
 * @example
 * const elementRef = useRef<HTMLElement>()
 * useResizeObserver<HTMLElement>({ element: elementRef, root: document.body, callback })
 * return <span ref={elementRef}>...</span>
 */
function useResizeObserver(options, dependencyList) {
    if (dependencyList === void 0) { dependencyList = []; }
    var element = options.element, callback = options.callback, _a = options.active, active = _a === void 0 ? true : _a;
    var ref = React.createRef();
    React.useEffect(function () {
        if (!('ResizeObserver' in globalThis) ||
            typeof ResizeObserver !== 'function') {
            return;
        }
        if (!active || typeof element === 'undefined' || element === null) {
            return;
        }
        if (!(element instanceof HTMLElement) &&
            !(element.current instanceof HTMLElement)) {
            // eslint-disable-next-line no-console
            console.warn('An element or ref was provided to useResizeObserver that was not an HTMLElement.');
            return;
        }
        var handleResize = function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            ref.current = entry;
            if (typeof callback === 'function') {
                callback(entry);
            }
        };
        var observer = new ResizeObserver(handleResize);
        observer.observe(element instanceof HTMLElement
            ? element
            : element.current);
        return function () {
            observer.disconnect();
        };
    }, __spreadArray([element, callback, active], __read(dependencyList), false));
    return ref;
}

/**
 * When a component needs to track an element's intersection, useIntersectionObserver
 * via a ref or callback function will track the first intersection entry invoking
 * the callback function and/or setting the value of the returned ref.
 *
 * @example
 * const elementRef = useRef<HTMLElement>()
 * useIntersectionObserver<HTMLElement>({ element: elementRef, root: document.body, callback })
 * return <span ref={elementRef}>...</span>
 */
function useIntersectionObserver(options, dependencyList) {
    if (dependencyList === void 0) { dependencyList = []; }
    var element = options.element, callback = options.callback, _a = options.active, active = _a === void 0 ? true : _a, _b = options.root, root = _b === void 0 ? null : _b, rootMargin = options.rootMargin, _c = options.threshold, threshold = _c === void 0 ? 1.0 : _c;
    var ref = React.createRef();
    React.useEffect(function () {
        if (!('IntersectionObserver' in globalThis) ||
            typeof IntersectionObserver !== 'function') {
            return;
        }
        if (!active || typeof element === 'undefined' || element === null) {
            return;
        }
        if (!(element instanceof HTMLElement) &&
            !(element.current instanceof HTMLElement)) {
            // eslint-disable-next-line no-console
            console.warn('An element or ref was provided to useIntersectionObserver that was not an HTMLElement.');
            return;
        }
        var handleIntersection = function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            ref.current = entry;
            if (typeof callback === 'function') {
                callback(entry);
            }
        };
        var observer = new IntersectionObserver(handleIntersection, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold
        });
        observer.observe(element instanceof HTMLElement
            ? element
            : element.current);
        return function () {
            observer.disconnect();
        };
    }, __spreadArray([
        element,
        callback,
        active,
        root,
        rootMargin,
        JSON.stringify(threshold)
    ], __read(dependencyList), false));
    return ref;
}

/**
 * Hook to provide the computed style property of an optionally provided
 * element or element ref. Defaults to `document.body` when no element is
 * provided.
 *
 * `getComputedStyle` can force layout or reflow calculations depending on the
 * CSS property being accessed. By default, the value is memoized to prevent
 * excessive layout thrashing. If the property needs to be updated based on some
 * other state, additional dependencies can be provided.
 *
 * @example
 * const height = useCSSPropertyValue('--some-css-height-var')
 *
 * If a property name and element that is not `document.body`. needs to be used,
 * passing in an object is necessary:
 *
 * @example
 * const height = useCSSPropertyValue({ property: '--some-css-height-var', element: document.getElementById('foo') })
 *
 */
function useCSSPropertyValue(options, dependencies) {
    if (dependencies === void 0) { dependencies = []; }
    var element;
    var property;
    if (typeof options === 'string') {
        property = options;
    }
    else {
        property = options.property;
        element = options.element;
    }
    var resolvedElement = (element instanceof HTMLElement ? element : element === null || element === void 0 ? void 0 : element.current) ||
        document.body;
    return React.useMemo(function () { return getComputedStyle(resolvedElement).getPropertyValue(property); }, __spreadArray([element], __read(dependencies), false));
}

var Integrations = {
    jira: { name: 'Jira' }
};

var integrationTypes = Object.keys(Integrations);
function IntegrationsActions(_a) {
    var integrations = _a.integrations, onAction = _a.onAction, collapse = _a.collapse, _b = _a.elementProps, elementProps /* c8 ignore next: default fallback value */ = _b === void 0 ? {} : _b;
    var t = useTranslation().t;
    var allowsIntegrations = useConfiguration().integrations;
    if (!allowsIntegrations) {
        return null;
    }
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: integrationTypes.map(function (integrationType) {
            var _a, _b;
            var integration = integrations === null || integrations === void 0 ? void 0 : integrations.find(function (_integration) { return _integration.url; });
            if (integration) {
                var key_1 = "open-in-".concat(integrationType);
                return (jsxRuntime.jsxs(cauldronReact.Link, __assign({ href: integration.url, target: "_blank", rel: "noopener noreferrer", onClick: function (event) { return onAction({ key: key_1 }, event); } }, elementProps, { children: [jsxRuntime.jsx(cauldronReact.Icon, { type: "share" }), t('Open in {{integration}}', {
                            integration: ((_a = Integrations[integrationType]) === null || _a === void 0 ? void 0 : _a.name /* c8 ignore next: default fallback value */) ||
                                /* c8 ignore next: default fallback value */ integrationType
                        })] }), key_1));
            }
            var key = "add-to-".concat(integrationType);
            var commonProps = {
                variant: 'secondary',
                onClick: function (event) {
                    return onAction({ key: key }, event);
                }
            };
            var label = t('Add to {{integration}}', {
                integration: ((_b = Integrations[integrationType]) === null || _b === void 0 ? void 0 : _b.name /* c8 ignore next: default fallback value */) ||
                    /* c8 ignore next: default fallback value */ integrationType
            });
            return collapse ? (jsxRuntime.jsx(cauldronReact.IconButton, __assign({}, commonProps, { icon: "share", label: label, large: true }), key)) : (jsxRuntime.jsxs(cauldronReact.Button, __assign({}, commonProps, elementProps, { children: [jsxRuntime.jsx(cauldronReact.Icon, { type: "share" }), label] }), key));
        }) }));
}
function Actions(_a) {
    var integrations = _a.integrations, onAction = _a.onAction, _b = _a.collapse, collapse = _b === void 0 ? false : _b, _c = _a.elementProps, elementProps /* c8 ignore next: default fallback value */ = _c === void 0 ? {} : _c;
    var t = useTranslation().t;
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(IntegrationsActions, { integrations: integrations, onAction: onAction, collapse: collapse, elementProps: elementProps }), jsxRuntime.jsx(cauldronReact.CopyButton, __assign({ value: location.href, variant: "secondary", onCopy: function () { return onAction({ key: 'copy-issue-link' }); }, hideVisibleLabel: collapse }, elementProps, { children: t('Copy issue link') }))] }));
}

var modules_1eab8564 = {"IssueHeader":"_IssueHeader_42e19b4f","containerContext":"_containerContext_42e19b4f","stickyTopBar":"_stickyTopBar_42e19b4f","title":"_title_42e19b4f","actions":"_actions_42e19b4f","sticky":"_sticky_42e19b4f","layoutContainer":"_layoutContainer_42e19b4f","noticeContainer":"_noticeContainer_42e19b4f","leadingHeaderActionContainer":"_leadingHeaderActionContainer_42e19b4f","subHeader":"_subHeader_42e19b4f","TopBar__paginationContainer":"_TopBar__paginationContainer_42e19b4f","TopBar__actions":"_TopBar__actions_42e19b4f","TopBar__overflow":"_TopBar__overflow_42e19b4f","TopBar__overflow__collapsed":"_TopBar__overflow__collapsed_42e19b4f"};

var IssueHeader = React.forwardRef(function (_a, ref) {
    var _b;
    var issue = _a.issue, leadingHeaderActions = _a.leadingHeaderActions, headerBreadcrumb = _a.headerBreadcrumb, totalIssueCount = _a.totalIssueCount, currentIssueNumber = _a.currentIssueNumber, issuePaginationLabel = _a.issuePaginationLabel, _c = _a.onAction, onAction = _c === void 0 ? function () { return null; } : _c, _d = _a.onNextIssue, onNextIssue = _d === void 0 ? function () { return null; } : _d, _e = _a.onPreviousIssue, onPreviousIssue = _e === void 0 ? function () { return null; } : _e, titleRef = _a.titleRef, className = _a.className, props = __rest(_a, ["issue", "leadingHeaderActions", "headerBreadcrumb", "totalIssueCount", "currentIssueNumber", "issuePaginationLabel", "onAction", "onNextIssue", "onPreviousIssue", "titleRef", "className"]);
    var t = useTranslation().t;
    var actionsRef = React.useRef(null);
    var topBarActionsRef = React.useRef(null);
    var paginationRef = React.useRef(null);
    var _f = __read(React.useState(false), 2), showTopBarTitle = _f[0], setShowTopBarTitle = _f[1];
    var _g = __read(React.useState(false), 2), showTopBarActions = _g[0], setShowTopBarActions = _g[1];
    var _h = __read(React.useState(false), 2), showTopBarPagination = _h[0], setShowTopBarPagination = _h[1];
    var _j = __read(React.useState(false), 2), collapseTopbarActions = _j[0], setCollapseTopbarActions = _j[1];
    var isFirstPage = currentIssueNumber === 1;
    var isLastPage = currentIssueNumber === totalIssueCount;
    var showPagination = typeof totalIssueCount === 'number' &&
        typeof currentIssueNumber === 'number' &&
        !!totalIssueCount &&
        !!currentIssueNumber;
    var showNotices = issue.needsReview || issue.duplicates;
    // Detect intersection of issue actions to determine if actions need
    // to be shown within the topbar
    var topBarHeight = useCSSPropertyValue('--top-bar-height');
    useIntersectionObserver({
        element: actionsRef,
        root: null,
        rootMargin: "-".concat(topBarHeight, " 0px 0px 0px"),
        threshold: 0.0,
        callback: function (entry) { return setShowTopBarActions(!entry.isIntersecting); }
    });
    // Detect intersection of title to determine if the title should be
    // be shown within the topbar
    useIntersectionObserver({
        element: titleRef,
        root: null,
        rootMargin: "-".concat(topBarHeight, " 0px 0px 0px"),
        threshold: 0.0,
        callback: function (entry) { return setShowTopBarTitle(!entry.isIntersecting); },
        active: typeof titleRef !== 'undefined'
    });
    // Detect intersection of pagination to determine if the pagination
    // should be shown within the topbar
    useIntersectionObserver({
        element: paginationRef,
        root: null,
        rootMargin: "-".concat(topBarHeight, " 0px 0px 0px"),
        threshold: 0.0,
        callback: function (entry) { return setShowTopBarPagination(!entry.isIntersecting); },
        active: showPagination
    });
    // Observe the container size of topbar actions to determine
    // when elements need to be collapsed down to a smaller form factor
    useResizeObserver({
        element: topBarActionsRef,
        callback: function (entry) {
            if (entry.target.scrollWidth > entry.target.clientWidth) {
                setCollapseTopbarActions(true);
            }
            else {
                setCollapseTopbarActions(false);
            }
        },
        active: showTopBarActions
    });
    return (jsxRuntime.jsxs("div", __assign({ ref: ref, className: classnames__default.default(modules_1eab8564.IssueHeader, className) }, props, { children: [jsxRuntime.jsx(cauldronReact.TopBar, { className: modules_1eab8564.stickyTopBar, children: jsxRuntime.jsxs("div", { className: classnames__default.default(modules_1eab8564.sticky, modules_1eab8564.containerContext), children: [jsxRuntime.jsxs("div", { className: modules_1eab8564.leadingHeaderActionContainer, children: [leadingHeaderActions, showPagination && showTopBarPagination && (jsxRuntime.jsx("div", { className: modules_1eab8564.TopBar__paginationContainer, children: jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(cauldronReact.IconButton, { icon: "chevron-left", label: t('Previous issue'), onClick: onPreviousIssue, large: true, disabled: isFirstPage }), jsxRuntime.jsx(cauldronReact.IconButton, { icon: "chevron-right", label: t('Next issue'), onClick: onNextIssue, large: true, disabled: isLastPage })] }) }))] }), jsxRuntime.jsx("div", { className: modules_1eab8564.title, style: { visibility: showTopBarTitle ? undefined : 'hidden' }, children: issue.help }), jsxRuntime.jsx("div", { className: modules_1eab8564.TopBar__actions, children: showTopBarActions && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("div", { ref: topBarActionsRef, className: classnames__default.default(modules_1eab8564.TopBar__overflow, (_b = {},
                                            _b[modules_1eab8564.TopBar__overflow__collapsed] = collapseTopbarActions,
                                            _b)), children: jsxRuntime.jsx(Actions, { integrations: issue.integrations, onAction: onAction, elementProps: { tabIndex: -1 } }) }), collapseTopbarActions && (jsxRuntime.jsx(Actions, { integrations: issue.integrations, onAction: onAction, collapse: true, elementProps: { tabIndex: -1 } }))] })) })] }) }), jsxRuntime.jsxs("div", { className: modules_1eab8564.containerContext, children: [showPagination && (jsxRuntime.jsx("nav", { "aria-label": t('Pagination'), className: modules_1eab8564.subHeader, ref: paginationRef, children: jsxRuntime.jsx(cauldronReact.Pagination, { className: modules_1eab8564.layoutContainer, itemsPerPage: 1, currentPage: currentIssueNumber, totalItems: totalIssueCount, previousPageLabel: t('Previous issue'), nextPageLabel: t('Next issue'), onPreviousPageClick: onPreviousIssue, onNextPageClick: onNextIssue, statusLabel: issuePaginationLabel || (jsxRuntime.jsx(Trans, { defaults: "Viewing <strong>{{ currentIssueNumber, number }}</strong> of <strong>{{ totalIssueCount, number }}</strong> of this rule", values: { currentIssueNumber: currentIssueNumber, totalIssueCount: totalIssueCount } })), hideStartEndPagination: true }) })), jsxRuntime.jsxs("div", { ref: actionsRef, className: modules_1eab8564.actions, children: [jsxRuntime.jsx("div", { children: headerBreadcrumb }), jsxRuntime.jsx("div", { children: jsxRuntime.jsx(Actions, { integrations: issue.integrations, onAction: onAction }) })] }), showNotices && (jsxRuntime.jsxs("div", { className: modules_1eab8564.noticeContainer, children: [issue.needsReview && (jsxRuntime.jsx(cauldronReact.Notice, { type: "caution", title: t('Potential issue that needs review'), children: t('An issue requires inspection by a human to determine if the issue is an actual violation of accessibility standards.') })), issue.duplicates && (jsxRuntime.jsx(cauldronReact.Notice, { type: "info", title: typeof issue.duplicates !== 'number'
                                    ? t('This page has related duplicates')
                                    : issue.duplicates === 1
                                        ? t('This page has one related duplicate')
                                        : t('This page has {{ duplicateCount, number }} related duplicates', { duplicateCount: issue.duplicates }), children: t('Identical accessibility issues on the same element (can be within the same page/state or across multiple).') }))] }))] })] })));
});
IssueHeader.displayName = 'IssueHeader';

var isRulesetTag = function (tag) { return tag in accessibilityStandards.rulesets; };
/**
 * Returns the first matching WCAG standard ruleset from a list of axe-core tags.
 *
 * @example
 * const wcagStandard = useWCAGStandard(['cat.color', 'wcag21aa', 'wcag143', 'en-301-549'])
 */
function useWCAGStandard(tags) {
    return React.useMemo(function () {
        var e_1, _a;
        if (!Array.isArray(tags)) {
            return null;
        }
        try {
            // There should only be a single WCAG standard tag in the list of tags, so
            // return the first one. If there's multiple wcag standard tags it's likely
            // an implementation bug.
            for (var tags_1 = __values(tags), tags_1_1 = tags_1.next(); !tags_1_1.done; tags_1_1 = tags_1.next()) {
                var tag = tags_1_1.value;
                var tagInfo = accessibilityStandards.getTagInfo(tag);
                if ((tagInfo === null || tagInfo === void 0 ? void 0 : tagInfo.standard) === 'WCAG' && isRulesetTag(tag)) {
                    return accessibilityStandards.rulesets[tag];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (tags_1_1 && !tags_1_1.done && (_a = tags_1.return)) _a.call(tags_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    }, [JSON.stringify(tags)]);
}

var isWCAGCheckpointTagInfo = function (tagInfo) {
    return 'checkpoint' in tagInfo && tagInfo.standard === 'WCAG';
};
function useWCAGCheckpointsTagInfo(tags) {
    var checkpoints = useCheckpointsTagInfo(tags);
    return React.useMemo(function () { return checkpoints.filter(isWCAGCheckpointTagInfo); }, [checkpoints]);
}

var DQU_ORIGIN = 'dequeuniversity.com';
var DQDOCS_ORIGIN = 'docs.deque.com';
var HelpLink = React.forwardRef(function (_a, ref) {
    var href = _a.href, props = __rest(_a, ["href"]);
    var t = useTranslation().t;
    var defaultText = t('Open issue help in new tab');
    var linkText = React.useMemo(function () {
        try {
            var url = new URL(href);
            switch (url.host) {
                case DQU_ORIGIN:
                    return t("Open {{product}} in new tab", {
                        product: 'Deque University'
                    });
                case DQDOCS_ORIGIN:
                    return t("Open {{product}} issue help in new tab", {
                        product: 'Deque Docs'
                    });
                default:
                    return defaultText;
            }
        }
        catch (_a) {
            return defaultText;
        }
    }, [href, t]);
    return (jsxRuntime.jsxs(cauldronReact.Link, __assign({ ref: ref, href: href, target: "_blank", rel: "noopener noreferrer" }, props, { children: [linkText, jsxRuntime.jsx(cauldronReact.Icon, { type: "external-link" })] })));
});
HelpLink.displayName = 'HelpLink';

var modules_6e4b5f81 = {"HowToFix":"_HowToFix_405f2c71","header":"_header_405f2c71","relatedNode":"_relatedNode_405f2c71","relatedNodeCode":"_relatedNodeCode_405f2c71"};

var RemediationDetails = function (_a) {
    var title = _a.title, remediations = _a.remediations;
    var remediationsWithAMessage = remediations.filter(function (_a) {
        var message = _a.message;
        return Boolean(message);
    });
    if (!remediationsWithAMessage.length) {
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    }
    return (jsxRuntime.jsxs("div", { children: [jsxRuntime.jsx("h3", { children: title }), remediationsWithAMessage.length === 1 ? (jsxRuntime.jsx("p", { children: remediationsWithAMessage[0].message })) : (jsxRuntime.jsx("ul", { children: remediationsWithAMessage.map(function (_a) {
                    var message = _a.message;
                    return (jsxRuntime.jsx("li", { children: message }, message));
                }) }))] }));
};
var HowToFix = React.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f;
    var issue = _a.issue, className = _a.className;
    var t = useTranslation().t;
    var remediation = issue.remediation, summary = issue.summary;
    var hasMustFixRemediations = !!((_b = remediation === null || remediation === void 0 ? void 0 : remediation.all) === null || _b === void 0 ? void 0 : _b.length) || !!((_c = remediation === null || remediation === void 0 ? void 0 : remediation.none) === null || _c === void 0 ? void 0 : _c.length);
    var hasBothRemediationTypes = !!((_d = remediation === null || remediation === void 0 ? void 0 : remediation.any) === null || _d === void 0 ? void 0 : _d.length) && hasMustFixRemediations;
    var hasRemediations = hasMustFixRemediations || !!((_e = remediation === null || remediation === void 0 ? void 0 : remediation.any) === null || _e === void 0 ? void 0 : _e.length);
    var mustFixRemediations = __spreadArray(__spreadArray([], __read(((remediation === null || remediation === void 0 ? void 0 : remediation.none) || [])), false), __read(((remediation === null || remediation === void 0 ? void 0 : remediation.all) || [])), false);
    var relatedNodes = remediation
        ? Object.values(remediation)
            .filter(function (r) { return !!r; })
            .flatMap(function (r) { return r; })
            .flatMap(function (r) { return r.relatedNodes || []; })
        : [];
    return (jsxRuntime.jsxs("div", { ref: ref, className: classnames__default.default(modules_6e4b5f81.HowToFix, className), children: [hasBothRemediationTypes && (jsxRuntime.jsx("p", { className: modules_6e4b5f81.header, children: t('There are some items that must be fixed and some items that require you to fix at least one.') })), hasRemediations ? (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(RemediationDetails, { remediations: mustFixRemediations, title: t('Must fix the following:') }), jsxRuntime.jsx(RemediationDetails, { remediations: (remediation === null || remediation === void 0 ? void 0 : remediation.any) || [], title: hasMustFixRemediations ||
                            (((_f = remediation === null || remediation === void 0 ? void 0 : remediation.any) === null || _f === void 0 ? void 0 : _f.length) && remediation.any.length > 1)
                            ? t('Must fix at least one of the following:')
                            : t('Must fix the following:') }), relatedNodes.map(function (node, index) { return (jsxRuntime.jsx("div", { className: modules_6e4b5f81.relatedNode, children: jsxRuntime.jsx(cauldronReact.Code, { allowCopy: true, className: modules_6e4b5f81.relatedNodeCode, language: "html", label: t("Related node {{ index }}", { index: index + 1 }), copyButtonProps: {
                                children: t("Copy related node {{ index }}", {
                                    index: index + 1
                                })
                            }, children: node.html }) }, node.target.join(','))); })] })) : (jsxRuntime.jsx("p", { children: summary ||
                    t('We are working on getting automatic fix advice for this rule. Please feel free to contact a Deque accessibility specialist for support.') }))] }));
});
HowToFix.displayName = 'HowToFix';

var ScreenshotImage = React.forwardRef(function (_a, ref) {
    var screenshotURL = _a.screenshotURL, props = __rest(_a, ["screenshotURL"]);
    var t = useTranslation().t;
    return (jsxRuntime.jsx("img", __assign({ src: screenshotURL, alt: t('screenshot of the page at the time this issue was generated'), ref: ref }, props)));
});
ScreenshotImage.displayName = 'ScreenshotImage';

var modules_81647ace = {"screenshot":"_screenshot_1531a285","screenshotEmptyState":"_screenshotEmptyState_1531a285","statusIcon":"_statusIcon_1531a285","screenshotLoading":"_screenshotLoading_1531a285","screenshotThumbnail":"_screenshotThumbnail_1531a285","screenshotImageLoading":"_screenshotImageLoading_1531a285","leadingActions":"_leadingActions_1531a285","trailingActions":"_trailingActions_1531a285","screenshotDialog":"_screenshotDialog_1531a285","screenshotDialogWrapper":"_screenshotDialogWrapper_1531a285","highlight":"_highlight_1531a285","highlightButton":"_highlightButton_1531a285"};

var ScreenshotDialog = function (_a) {
    var issue = _a.issue, onClose = _a.onClose, props = __rest(_a, ["issue", "onClose"]);
    var highlightButtonRef = React.useRef(null);
    var screenshotURL = issue.screenshotURL, boundingBox = issue.boundingBox, help = issue.help;
    var screenshotRef = React.useRef(null);
    var _b = __read(React.useState(1), 2), scaleDownRatio = _b[0], setScaleDownRatio = _b[1];
    var _c = __read(React.useState(!!boundingBox), 2), showHighlight = _c[0], setShowHighlight = _c[1];
    var t = useTranslation().t;
    var screenshotIsOffscreen = (boundingBox === null || boundingBox === void 0 ? void 0 : boundingBox.width) === 0 && (boundingBox === null || boundingBox === void 0 ? void 0 : boundingBox.height) === 0;
    var getCurrentRatio = function () {
        if (!screenshotRef.current) {
            return;
        }
        // naturalWidth comes back 0 during initial render
        var originalWidth = screenshotRef.current.naturalWidth || 1;
        var ratio = screenshotRef.current.width / originalWidth || 1;
        setScaleDownRatio(ratio);
    };
    useResizeObserver({
        element: screenshotRef,
        callback: getCurrentRatio
    });
    var highlightStyles = React.useMemo(function () {
        if (!boundingBox || !scaleDownRatio) {
            return;
        }
        return {
            width: "".concat(boundingBox.width * scaleDownRatio, "px"),
            height: "".concat(boundingBox.height * scaleDownRatio, "px"),
            top: "".concat(boundingBox.y * scaleDownRatio, "px"),
            left: "".concat(boundingBox.x * scaleDownRatio, "px")
        };
    }, [boundingBox, scaleDownRatio]);
    var highlightRef = React.useCallback(function getInitialHighlight(ref) {
        if (!ref || screenshotIsOffscreen) {
            return;
        }
        ref.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
            inline: 'nearest'
        });
    }, [screenshotIsOffscreen]);
    return (jsxRuntime.jsxs(cauldronReact.Modal, __assign({ heading: t("Screenshot: {{ruleHelpText}}", {
            ruleHelpText: help
        }), onClose: onClose, className: modules_81647ace.screenshotDialog }, props, { children: [jsxRuntime.jsx(cauldronReact.ModalContent, { children: jsxRuntime.jsxs("div", { className: modules_81647ace.screenshotDialogWrapper, children: [jsxRuntime.jsx(ScreenshotImage, { screenshotURL: screenshotURL, ref: screenshotRef }), showHighlight && highlightStyles && !screenshotIsOffscreen && (jsxRuntime.jsx("div", { "data-testid": "screenshot-highlight", className: modules_81647ace.highlight, style: highlightStyles, ref: highlightRef }))] }) }), jsxRuntime.jsxs(cauldronReact.ModalFooter, { children: [boundingBox && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [screenshotIsOffscreen && (jsxRuntime.jsx(cauldronReact.Tooltip, { variant: "info", target: highlightButtonRef, placement: "top", children: t('We are unable to highlight the element because it is scrolled out of view in the screenshot. This can happen when elements are offscreen or within scrollable panes.') })), jsxRuntime.jsxs(cauldronReact.Button, { ref: highlightButtonRef, variant: "secondary", role: "switch", "aria-checked": !screenshotIsOffscreen && showHighlight, className: modules_81647ace.highlightButton, onClick: function () {
                                    return !screenshotIsOffscreen && setShowHighlight(!showHighlight);
                                }, "aria-disabled": screenshotIsOffscreen, children: [jsxRuntime.jsx(cauldronReact.Icon, { type: "highlight" }), t('Highlight Issue')] })] })), jsxRuntime.jsx(cauldronReact.Button, { variant: "secondary", onClick: onClose, children: t('Close') })] })] })));
};

var ContactSupport = function () {
    return (jsxRuntime.jsx("p", { children: jsxRuntime.jsxs(Trans, { children: ["If the problem continues,", ' ', jsxRuntime.jsx("a", { href: "mailto:helpdesk@deque.com", children: "contact support" })] }) }));
};
var ScreenshotConfigurationError = function (_a) {
    var configuration = _a.configuration;
    var t = useTranslation().t;
    var configurationError = React.useMemo(function () {
        switch (configuration) {
            case ScreenshotConfiguration.MixedOn:
                return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("strong", { children: t('Screenshot was not captured because configuration was not turned on during the time of this scan run.') }), jsxRuntime.jsx(ContactSupport, {})] }));
            case ScreenshotConfiguration.Off:
                return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("strong", { children: t('Screenshots configuration was not turned on during the time of this scan run.') }), jsxRuntime.jsx(ContactSupport, {})] }));
            case ScreenshotConfiguration.OffLocked:
                return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("strong", { children: t('Screenshots configuration was not turned on during the time of this scan run.') }), jsxRuntime.jsx("p", { children: t('Contact your organization admin.') })] }));
            case 'missing-configuration':
                return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("strong", { children: t('No screenshot was found for this issue.') }), jsxRuntime.jsx(ContactSupport, {})] }));
            // This is indicative of an error state where the screenshot is supposed
            // to exist and was unable to be displayed for one reason or another
            default: {
                return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("strong", { children: t('There was an issue rendering the screenshot.') }), jsxRuntime.jsx(ContactSupport, {})] }));
            }
        }
    }, [t, configuration]);
    return jsxRuntime.jsx("div", { children: configurationError });
};

var ScreenshotEmptyState = function (_a) {
    var _b;
    var className = _a.className, screenshotStatus = _a.screenshotStatus, screenshotConfiguration = _a.screenshotConfiguration, props = __rest(_a, ["className", "screenshotStatus", "screenshotConfiguration"]);
    var isLoading = screenshotStatus === 'loading';
    var hasError = screenshotStatus === 'error';
    var unknownConfiguration = !screenshotConfiguration;
    return (jsxRuntime.jsx("div", __assign({ className: classnames__default.default(modules_81647ace.screenshotEmptyState, className, (_b = {},
            _b[modules_81647ace.screenshotLoading] = isLoading,
            _b)) }, props, { children: !isLoading && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("span", { className: modules_81647ace.statusIcon, children: jsxRuntime.jsx(cauldronReact.Icon, { type: hasError || unknownConfiguration ? 'images' : 'gears' }) }), jsxRuntime.jsx(ScreenshotConfigurationError, { configuration: hasError
                        ? null
                        : unknownConfiguration
                            ? 'missing-configuration'
                            : screenshotConfiguration })] })) })));
};

var Screenshot = React.forwardRef(function (_a, ref) {
    var _b;
    var _c;
    var className = _a.className, issue = _a.issue, leadingScreenshotActions = _a.leadingScreenshotActions, screenshotStatus = _a.screenshotStatus, screenshotConfiguration = _a.screenshotConfiguration, props = __rest(_a, ["className", "issue", "leadingScreenshotActions", "screenshotStatus", "screenshotConfiguration"]);
    var screenshotURL = issue.screenshotURL;
    var t = useTranslation().t;
    var _d = __read(React.useState(false), 2), onLoadError = _d[0], setOnLoadError = _d[1];
    var _e = __read(React.useState(!screenshotURL), 2), imageLoaded = _e[0], setImageLoaded = _e[1];
    var imageRef = React.useRef(null);
    var _f = __read(React.useState(false), 2), showFullScreenshotDialog = _f[0], setShowFullScreenshotDialog = _f[1];
    var isLoading = (!imageLoaded && !((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.complete)) ||
        screenshotStatus === 'loading';
    var hasError = screenshotStatus === 'error' || onLoadError;
    var status = hasError
        ? 'error'
        : isLoading
            ? 'loading'
            : screenshotStatus || 'complete';
    var canRenderScreenshot = (!screenshotStatus || screenshotStatus === 'complete') &&
        !!screenshotURL &&
        !hasError;
    var showEmptyState = isLoading || hasError || !screenshotURL;
    React.useEffect(function () {
        if (screenshotURL) {
            setOnLoadError(false);
            setImageLoaded(false);
        }
    }, [screenshotURL]);
    return (jsxRuntime.jsxs("div", __assign({ ref: ref, className: classnames__default.default(modules_81647ace.screenshot, className) }, props, { children: [!isLoading && leadingScreenshotActions && (jsxRuntime.jsx("div", { className: modules_81647ace.leadingActions, children: leadingScreenshotActions })), showEmptyState && (jsxRuntime.jsx(ScreenshotEmptyState, { screenshotConfiguration: screenshotConfiguration, screenshotStatus: status })), canRenderScreenshot && (jsxRuntime.jsx("div", { className: classnames__default.default(modules_81647ace.screenshotThumbnail, (_b = {},
                    _b[modules_81647ace.screenshotImageLoading] = isLoading,
                    _b)), children: jsxRuntime.jsx(ScreenshotImage, { ref: imageRef, screenshotURL: screenshotURL, onError: function () { return setOnLoadError(true); }, onLoad: function () { return setImageLoaded(true); } }, screenshotURL) })), !isLoading && canRenderScreenshot && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("div", { className: modules_81647ace.trailingActions, children: jsxRuntime.jsx(cauldronReact.Button, { variant: "tertiary", onClick: function () { return setShowFullScreenshotDialog(true); }, children: t('View full screenshot') }) }), jsxRuntime.jsx(ScreenshotDialog, { issue: __assign(__assign({}, issue), { screenshotURL: screenshotURL }), show: showFullScreenshotDialog, onClose: function () { return setShowFullScreenshotDialog(false); } })] }))] })));
});
Screenshot.displayName = 'Screenshot';

var modules_76c20546 = {"IssueDetails":"_IssueDetails_9e1a76e8","QuickLinks":"_QuickLinks_9e1a76e8","resourceLinks":"_resourceLinks_9e1a76e8","pageUrl":"_pageUrl_9e1a76e8","toggleIcon":"_toggleIcon_9e1a76e8","testUrl":"_testUrl_9e1a76e8","testUrlExpanded":"_testUrlExpanded_9e1a76e8","analyzedValues":"_analyzedValues_9e1a76e8"};

var IssueDetails = React.forwardRef(function (_a, ref) {
    var _b;
    var issue = _a.issue, hideIssueDetailsScreenshot = _a.hideIssueDetailsScreenshot, leadingScreenshotActions = _a.leadingScreenshotActions, screenshotStatus = _a.screenshotStatus, screenshotConfiguration = _a.screenshotConfiguration, className = _a.className, props = __rest(_a, ["issue", "hideIssueDetailsScreenshot", "leadingScreenshotActions", "screenshotStatus", "screenshotConfiguration", "className"]);
    var t = useTranslation().t;
    var testPageTitle = issue.testPageTitle, testUrl = issue.testUrl, screenTitle = issue.screenTitle, mobilePlatform = issue.mobilePlatform, appIdentifier = issue.appIdentifier, analyzedValues = issue.analyzedValues, ancestry = issue.ancestry, source = issue.source, selector = issue.selector, xpathSelector = issue.xpathSelector, _c = issue.tags, tags = _c === void 0 ? [] : _c;
    var allowsScreenshots = useConfiguration().screenshots;
    var wcagStandard = useWCAGStandard(tags);
    var wcagCheckpoints = useWCAGCheckpointsTagInfo(tags);
    var testUrlRef = React.useRef(null);
    var _d = __read(React.useState(false), 2), showTestUrlToggle = _d[0], setShowTestUrlToggle = _d[1];
    var _e = __read(React.useState(false), 2), testUrlExpanded = _e[0], setTestUrlExpanded = _e[1];
    var quickLinksId = "quick-links-".concat(utils.useId());
    var testUrlId = "test-url-".concat(utils.useId());
    useResizeObserver({
        element: testUrlRef,
        callback: function (entry) {
            var overflowElement = entry.target;
            var hasOverflow = overflowElement.clientHeight < overflowElement.scrollHeight;
            setShowTestUrlToggle(hasOverflow || showTestUrlToggle);
        },
        active: !!testUrl
    });
    var handleToggleTestUrlExpanded = function () { return setTestUrlExpanded(!testUrlExpanded); };
    return (jsxRuntime.jsxs("div", __assign({ ref: ref, className: classnames__default.default(modules_76c20546.IssueDetails, className) }, props, { children: [jsxRuntime.jsxs("nav", { "aria-labelledby": quickLinksId, className: modules_76c20546.QuickLinks, children: [jsxRuntime.jsx("strong", { id: quickLinksId, children: t('Quick links:') }), jsxRuntime.jsxs("ol", { children: [jsxRuntime.jsx("li", { children: jsxRuntime.jsx(cauldronReact.Link, { href: "#issue-location", children: t('Issue location') }) }), jsxRuntime.jsx("li", { children: jsxRuntime.jsx(cauldronReact.Link, { href: "#how-to-fix", children: t('How to fix') }) })] })] }), jsxRuntime.jsx("h2", { id: "issue-location", tabIndex: -1, children: t('Issue location') }), testPageTitle && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "page-title", children: t('Page title') }), testPageTitle] })), testUrl && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "page-url", children: t('Page URL') }), jsxRuntime.jsxs("div", { className: modules_76c20546.pageUrl, children: [jsxRuntime.jsx("div", { id: testUrlId, ref: testUrlRef, className: classnames__default.default(modules_76c20546.testUrl, (_b = {},
                                    _b[modules_76c20546.testUrlExpanded] = testUrlExpanded,
                                    _b)), children: testUrl }), showTestUrlToggle && (jsxRuntime.jsxs(cauldronReact.Button, { variant: "tertiary", "aria-expanded": testUrlExpanded, "aria-controls": testUrlId, onClick: handleToggleTestUrlExpanded, children: [jsxRuntime.jsx(cauldronReact.Icon, { className: modules_76c20546.toggleIcon, type: testUrlExpanded ? 'minus' : 'plus' }), testUrlExpanded ? t('Show less URL') : t('Show full URL')] })), jsxRuntime.jsxs("a", { href: testUrl, target: "_blank", rel: "noopener noreferrer", children: [t('Opens page URL in new tab'), " ", jsxRuntime.jsx(cauldronReact.Icon, { type: "external-link" })] })] })] })), screenTitle && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "screen-title", children: t('Screen title') }), screenTitle] })), mobilePlatform && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "operating-system-os", children: t('Operating system (OS)') }), mobilePlatform] })), appIdentifier && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "app-identifier", children: t('App identifier') }), appIdentifier] })), allowsScreenshots && !hideIssueDetailsScreenshot && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "screenshot", children: t('Page screenshot') }), jsxRuntime.jsx(Screenshot, { issue: issue, leadingScreenshotActions: leadingScreenshotActions, screenshotStatus: screenshotStatus, screenshotConfiguration: screenshotConfiguration })] })), analyzedValues && Object.keys(analyzedValues).length && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("h3", { id: "analyzed-values", children: t('Analyzed values') }), jsxRuntime.jsx("div", { className: classnames__default.default('Code', 'hljs', modules_76c20546.analyzedValues), children: jsxRuntime.jsx("ul", { children: Object.entries(analyzedValues).map(function (_a) {
                                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                return (jsxRuntime.jsx("li", { children: "".concat(key, ": ").concat(value) }, key));
                            }) }) })] })), ancestry && (jsxRuntime.jsx(cauldronReact.Code, { language: "css", label: jsxRuntime.jsx("h3", { id: "element-ancestry", children: t('Ancestry') }), copyButtonProps: {
                    children: t('Copy ancestry'),
                    notificationLabel: t('Copied')
                }, allowCopy: true, children: ancestry.join(', ') })), source && (jsxRuntime.jsx(cauldronReact.Code, { language: "html", label: jsxRuntime.jsx("h3", { id: "element-source", children: t('Element source') }), copyButtonProps: {
                    children: t('Copy element source'),
                    notificationLabel: t('Copied')
                }, allowCopy: true, children: source })), selector && (jsxRuntime.jsx(cauldronReact.Code, { language: "css", label: jsxRuntime.jsx("h3", { id: "css-selector", children: t('CSS selector') }), copyButtonProps: {
                    children: t('Copy CSS selector'),
                    notificationLabel: t('Copied')
                }, allowCopy: true, children: selector.join(', ') })), xpathSelector && (jsxRuntime.jsx(cauldronReact.Code, { label: jsxRuntime.jsx("h3", { id: "xpath", children: t('XPath') }), copyButtonProps: {
                    children: t('Copy XPath'),
                    notificationLabel: t('Copied')
                }, allowCopy: true, children: xpathSelector.join(', ') })), jsxRuntime.jsx("h2", { id: "how-to-fix", tabIndex: -1, children: t('How to fix') }), jsxRuntime.jsx("div", { children: jsxRuntime.jsx(HowToFix, { issue: issue }) }), jsxRuntime.jsxs("div", { className: modules_76c20546.resourceLinks, children: [jsxRuntime.jsx("h3", { children: t('Additional resources:') }), wcagCheckpoints.length ? (jsxRuntime.jsxs("ul", { children: [jsxRuntime.jsx("li", { children: jsxRuntime.jsx(HelpLink, { href: issue.helpUrl }) }), wcagCheckpoints.map(function (tagInfo) { return (jsxRuntime.jsxs("li", { children: [wcagStandard && jsxRuntime.jsxs("strong", { children: [wcagStandard.name, ":"] }), ' ', jsxRuntime.jsxs(cauldronReact.Link, { href: tagInfo.understandingUrl, children: [tagInfo.checkpoint, " ", tagInfo.checkpointDescription, jsxRuntime.jsx(cauldronReact.Icon, { type: "external-link" })] })] }, tagInfo.value)); })] })) : (jsxRuntime.jsx(HelpLink, { href: issue.helpUrl }))] })] })));
});
IssueDetails.displayName = 'IssueDetails';

function SuccessCriteriaBadge(_a) {
    var checkpoint = _a.checkpoint, ruleset = _a.ruleset;
    var t = useTranslation().t;
    var showWCAGUnderstandingLink = isWCAGCheckpoint(checkpoint);
    return (jsxRuntime.jsxs(cauldronReact.Badge, { children: [jsxRuntime.jsxs(cauldronReact.BadgeLabel, { children: [ruleset.name, ":"] }), showWCAGUnderstandingLink ? (jsxRuntime.jsxs(cauldronReact.Link, { href: checkpoint.understandingUrl, target: "_blank", rel: "noopener noreferrer", children: [checkpoint.checkpoint, " ", checkpoint.checkpointDescription, jsxRuntime.jsx(cauldronReact.Icon, { label: t('Opens in new tab'), type: "external-link" })] })) : (checkpoint.checkpoint)] }));
}
SuccessCriteriaBadge.displayName = 'SuccessCriteriaBadge';

function assertNever$1(x) {
    throw new Error("Unexpected value: ".concat(x));
}
var ImpactBadgeLabel = function (_a) {
    var type = _a.type, hideLabel = _a.hideLabel;
    var t = useTranslation().t;
    if (hideLabel) {
        switch (type) {
            case 'critical':
                return t('Critical');
            case 'serious':
                return t('Serious');
            case 'moderate':
                return t('Moderate');
            case 'minor':
                return t('Minor');
            default: {
                assertNever$1(type);
            }
        }
    }
    switch (type) {
        case 'critical':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Impact:" }), "Critical"] }));
        case 'serious':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Impact:" }), "Serious"] }));
        case 'moderate':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Impact:" }), "Moderate"] }));
        case 'minor':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Impact:" }), "Minor"] }));
        default: {
            assertNever$1(type);
        }
    }
};

function assertNever(x) {
    throw new Error("Unexpected value: ".concat(x));
}
function ResultBadgeLabel(_a) {
    var result = _a.result;
    switch (result) {
        case 'failed':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Result:" }), "Failed"] }));
        case 'passed':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Result:" }), "Passed"] }));
        case 'not-applicable':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Result:" }), "Not Applicable"] }));
        case 'issue-failed':
            return (jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Result:" }), "Issue"] }));
        default:
            assertNever(result);
    }
}

var modules_e9940ca4 = {"RuleDetails":"_RuleDetails_62d92431","headerSection":"_headerSection_62d92431","headerOverline":"_headerOverline_62d92431","headerDescription":"_headerDescription_62d92431","badgeSection":"_badgeSection_62d92431"};

var RuleDetails = React.forwardRef(function (_a, ref) {
    var issue = _a.issue, titleRef = _a.titleRef, className = _a.className, props = __rest(_a, ["issue", "titleRef", "className"]);
    var ruleName = issue.ruleName, ruleId = issue.ruleId, help = issue.help, description = issue.description, helpUrl = issue.helpUrl, impact = issue.impact, isExperimental = issue.isExperimental, needsReview = issue.needsReview, _b = issue.tags, tags = _b === void 0 ? [] : _b, ruleResults = issue.ruleResults;
    var wcagStandard = useWCAGStandard(tags);
    var checkpointsTagInfo = useWCAGCheckpointsTagInfo(tags);
    var standards = useAccessibilityStandards(tags);
    var checkpointsWithStandardInfo = React.useMemo(function () {
        return checkpointsTagInfo.map(function (checkpoint) { return (__assign(__assign({}, checkpoint), { standardInfo: standards.find(function (s) { return s.type === checkpoint.standard; }) })); });
    }, [checkpointsTagInfo, standards]);
    var isBestPractice = React.useMemo(function () { return tags.includes('best-practice'); }, [JSON.stringify(tags)]);
    return (jsxRuntime.jsxs("div", __assign({ className: classnames__default.default(modules_e9940ca4.RuleDetails, className), ref: ref }, props, { children: [jsxRuntime.jsxs("div", { className: modules_e9940ca4.headerSection, children: [jsxRuntime.jsx("span", { className: modules_e9940ca4.headerOverline, children: ruleName || ruleId }), jsxRuntime.jsx("h1", { ref: titleRef, children: help }), description && (jsxRuntime.jsx("p", { className: modules_e9940ca4.headerDescription, children: description })), jsxRuntime.jsx(HelpLink, { href: helpUrl })] }), jsxRuntime.jsxs("div", { className: modules_e9940ca4.badgeSection, children: [impact && (jsxRuntime.jsx(cauldronReact.ImpactBadge, { type: impact, label: jsxRuntime.jsx(ImpactBadgeLabel, { type: impact }) })), isExperimental && (jsxRuntime.jsx(cauldronReact.Badge, { children: jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Rule:" }), " Experimental"] }) })), wcagStandard &&
                        (checkpointsWithStandardInfo.length ? (checkpointsWithStandardInfo.map(function (checkpointInfo) { return (jsxRuntime.jsx(SuccessCriteriaBadge, { ruleset: wcagStandard, checkpoint: checkpointInfo }, checkpointInfo === null || checkpointInfo === void 0 ? void 0 : checkpointInfo.value)); })) : (jsxRuntime.jsx(cauldronReact.Badge, { children: jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: wcagStandard.name }) }))), needsReview && (jsxRuntime.jsx(cauldronReact.Badge, { children: jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Result:" }), " Needs Review"] }) })), isBestPractice && (jsxRuntime.jsx(cauldronReact.Badge, { children: jsxRuntime.jsxs(Trans, { children: [jsxRuntime.jsx(cauldronReact.BadgeLabel, { children: "Rule:" }), { deque: 'Deque' }, " Best Practice"] }) })), ruleResults && (jsxRuntime.jsx(cauldronReact.Badge, { children: jsxRuntime.jsx(ResultBadgeLabel, { result: ruleResults }) }))] })] })));
});
RuleDetails.displayName = 'RuleDetails';

// used for components that need to access and set the ref
function setRef(ref, element) {
    if (!ref) {
        return;
    }
    if (typeof ref === 'function') {
        ref(element);
    }
    else {
        // eslint-disable-next-line
        // @ts-ignore
        // we need to overwrite the existing value in some special cases
        ref.current = element;
    }
}

/**
 * When a component needs to track an internal ref on a component that has a
 * forwarded ref, useSharedRef will return a MutableRefObject<T> that will
 * correctly invoke the parent ref as well providing an internal ref.
 *
 * @example
 * React.forwardRef(function Component({ children }, ref) {
 *   const internalRef = useSharedRef<HTMLElement>(ref)
 *   if (internalRef.current) {
 *     // do something with the internal ref...
 *   }
 *   return (<div ref={internalRef}>...</div>)
 * })
 */
function useSharedRef(ref) {
    var internalRef = React.useRef();
    React.useEffect(function () {
        setRef(ref, internalRef.current);
    }, [ref]);
    return internalRef;
}

var modules_62d27841 = {"Issue":"_Issue_6dbb52aa","IssueContainer":"_IssueContainer_6dbb52aa","columnLayout":"_columnLayout_6dbb52aa","issueRuleDetails":"_issueRuleDetails_6dbb52aa","issueDetails":"_issueDetails_6dbb52aa","issueMetadata":"_issueMetadata_6dbb52aa","columnRight":"_columnRight_6dbb52aa"};

var LAYOUT_BREAKPOINT_PX = 1100;
var Issue = React.forwardRef(function (_a, ref) {
    var issue = _a.issue, titleRef = _a.titleRef, rightColumnChildren = _a.rightColumnChildren, leadingScreenshotActions = _a.leadingScreenshotActions, screenshotStatus = _a.screenshotStatus, screenshotConfiguration = _a.screenshotConfiguration, className = _a.className, props = __rest(_a, ["issue", "titleRef", "rightColumnChildren", "leadingScreenshotActions", "screenshotStatus", "screenshotConfiguration", "className"]);
    var issueRef = useSharedRef(ref);
    var _b = __read(React.useState(true), 2), isOneColumnLayout = _b[0], setIsOneColumnLayout = _b[1];
    var allowsScreenshots = useConfiguration().screenshots;
    var handleResize = React.useCallback(function (entry) {
        var containerWidth = entry.target.clientWidth;
        setIsOneColumnLayout(containerWidth < LAYOUT_BREAKPOINT_PX);
    }, []);
    useResizeObserver({
        element: issueRef,
        callback: handleResize,
        active: allowsScreenshots
    });
    var showScreenshotOnRightSide = !isOneColumnLayout && allowsScreenshots && !rightColumnChildren;
    var showMetadataOnRightSide = !showScreenshotOnRightSide && !rightColumnChildren;
    return (jsxRuntime.jsx("div", __assign({ className: classnames__default.default(modules_62d27841.Issue, className), ref: issueRef }, props, { children: jsxRuntime.jsxs("div", { className: modules_62d27841.IssueContainer, children: [jsxRuntime.jsx(RuleDetails, { className: modules_62d27841.issueRuleDetails, issue: issue, titleRef: titleRef }), jsxRuntime.jsxs("div", { className: modules_62d27841.columnLayout, children: [jsxRuntime.jsxs("div", { className: modules_62d27841.columnLeft, children: [jsxRuntime.jsx(IssueDetails, { issue: issue, hideIssueDetailsScreenshot: showScreenshotOnRightSide, className: modules_62d27841.issueDetails, leadingScreenshotActions: leadingScreenshotActions, screenshotStatus: screenshotStatus, screenshotConfiguration: screenshotConfiguration }), !showMetadataOnRightSide && (jsxRuntime.jsx(IssueMetadata, { className: modules_62d27841.issueMetadata, issue: issue }))] }), jsxRuntime.jsx("div", { className: modules_62d27841.columnRight, children: rightColumnChildren ||
                                (showScreenshotOnRightSide ? (jsxRuntime.jsx(Screenshot, { issue: issue, leadingScreenshotActions: leadingScreenshotActions, screenshotConfiguration: screenshotConfiguration, screenshotStatus: screenshotStatus })) : (jsxRuntime.jsx(IssueMetadata, { className: modules_62d27841.issueMetadata, issue: issue }))) })] })] }) })));
});
Issue.displayName = 'Issue';

var modules_4d37d440 = {"IssuePage":"_IssuePage_ce538032","scrollPadding":"_scrollPadding_ce538032","IssuePageContainer":"_IssuePageContainer_ce538032"};

var IssuePage = React.forwardRef(function (_a, ref) {
    var issue = _a.issue, leadingHeaderActions = _a.leadingHeaderActions, headerBreadcrumb = _a.headerBreadcrumb, rightColumnChildren = _a.rightColumnChildren, totalIssueCount = _a.totalIssueCount, currentIssueNumber = _a.currentIssueNumber, onNextIssue = _a.onNextIssue, onPreviousIssue = _a.onPreviousIssue, issuePaginationLabel = _a.issuePaginationLabel, leadingScreenshotActions = _a.leadingScreenshotActions, screenshotConfiguration = _a.screenshotConfiguration, screenshotStatus = _a.screenshotStatus, onAction = _a.onAction, className = _a.className, props = __rest(_a, ["issue", "leadingHeaderActions", "headerBreadcrumb", "rightColumnChildren", "totalIssueCount", "currentIssueNumber", "onNextIssue", "onPreviousIssue", "issuePaginationLabel", "leadingScreenshotActions", "screenshotConfiguration", "screenshotStatus", "onAction", "className"]);
    var titleRef = React.useRef(null);
    var help = issue.help;
    React.useEffect(function () {
        document.documentElement.classList.add(modules_4d37d440.scrollPadding);
        return function () {
            document.documentElement.classList.remove(modules_4d37d440.scrollPadding);
        };
    }, []);
    React.useEffect(function () {
        var previousTitle = document.title;
        document.title = help;
        return function () {
            document.title = previousTitle;
        };
    }, [help]);
    return (jsxRuntime.jsx("div", __assign({ className: classnames__default.default(modules_4d37d440.IssuePage, className), ref: ref }, props, { children: jsxRuntime.jsxs("div", { className: modules_4d37d440.IssuePageContainer, children: [jsxRuntime.jsx(IssueHeader, { issue: issue, leadingHeaderActions: leadingHeaderActions, headerBreadcrumb: headerBreadcrumb, totalIssueCount: totalIssueCount, currentIssueNumber: currentIssueNumber, issuePaginationLabel: issuePaginationLabel, titleRef: titleRef, onNextIssue: onNextIssue, onPreviousIssue: onPreviousIssue, onAction: onAction, className: modules_4d37d440.issueHeader }), jsxRuntime.jsx(Issue, { issue: issue, titleRef: titleRef, rightColumnChildren: rightColumnChildren, leadingScreenshotActions: leadingScreenshotActions, screenshotConfiguration: screenshotConfiguration, screenshotStatus: screenshotStatus })] }) })));
});
IssuePage.displayName = 'IssuePage';

/**
 * Hook to isolate an element for screen readers by setting `aria-hidden="true"`
 * for any sibling or ancestor element that does not contain the target element.
 */
function useAriaIsolation(options) {
    var element = options.element, _a = options.active, active = _a === void 0 ? true : _a;
    var affectedElements = React.useRef([]);
    var cleanup = function () {
        var e_1, _a;
        try {
            for (var _b = __values(affectedElements.current), _c = _b.next(); !_c.done; _c = _b.next()) {
                var affectedElement = _c.value;
                affectedElement.removeAttribute('aria-hidden');
                affectedElements.current = [];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    React.useEffect(function () {
        if (!active || typeof element === 'undefined' || element === null) {
            return;
        }
        var targetElement = element instanceof HTMLElement
            ? element
            : element.current;
        if (!(targetElement instanceof HTMLElement)) {
            // eslint-disable-next-line no-console
            console.warn('An element or ref was provided to useAriaIsolation that was not an HTMLElement.');
            return;
        }
        if (!active) {
            cleanup();
        }
        else {
            var parentNode = targetElement.parentNode;
            while (parentNode && parentNode.nodeName !== 'HTML') {
                Array.prototype.slice
                    .call(parentNode.children)
                    .forEach(function (child) {
                    if (child !== targetElement && !child.contains(targetElement)) {
                        if (child.getAttribute('aria-hidden') === 'true') {
                            return;
                        }
                        affectedElements.current.push(child);
                        child.setAttribute('aria-hidden', 'true');
                    }
                });
                parentNode = parentNode.parentNode;
            }
        }
        return cleanup;
    }, [active, element]);
}

var modules_d6bb9f7a = {"issueFilter":"_issueFilter_664ab189","filters":"_filters_664ab189","activeFilter":"_activeFilter_664ab189","searchFieldCounter":"_searchFieldCounter_664ab189","emptyState":"_emptyState_664ab189","actions":"_actions_664ab189","issueFilterItem":"_issueFilterItem_664ab189","issueFilterItemDescription":"_issueFilterItemDescription_664ab189"};

function IssueFilter(_a) {
    var openProp = _a.open, buttonLabel = _a.buttonLabel, overlayLabel = _a.overlayLabel, selectedIssuesCount = _a.selectedIssuesCount, onClearAllFilters = _a.onClearAllFilters, onShowResults = _a.onShowResults, onOpenChange = _a.onOpenChange, _b = _a.searchField, searchField = _b === void 0 ? false : _b, children = _a.children, props = __rest(_a, ["open", "buttonLabel", "overlayLabel", "selectedIssuesCount", "onClearAllFilters", "onShowResults", "onOpenChange", "searchField", "children"]);
    var searchFieldProps = searchField
        ? props.searchFieldProps
        : undefined;
    var anchorButtonRef = React.useRef(null);
    var overlayRef = React.useRef(null);
    var t = useTranslation().t;
    var _c = __read(React.useState(false), 2), open = _c[0], setOpen = _c[1];
    var isControlled = typeof openProp === 'boolean';
    var isOpen = isControlled ? openProp : open;
    var chevronType = isOpen ? 'triangle-up' : 'triangle-down';
    useAriaIsolation({
        element: overlayRef,
        active: isOpen
    });
    var handleOpenChange = React.useCallback(function (openState) {
        if (typeof onOpenChange === 'function' && isControlled) {
            onOpenChange(openState);
        }
        else {
            setOpen(openState);
        }
    }, [isControlled]);
    var handleKeyDown = function (event) {
        if (event.key === 'ArrowDown') {
            handleOpenChange(true);
        }
    };
    var handleClickOutside = React.useCallback(function (event) {
        var _a;
        if (event.target === anchorButtonRef.current ||
            ((_a = anchorButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            return;
        }
        handleOpenChange(false);
    }, []);
    var handleSearchKeyUp = React.useCallback(function (event) {
        if (searchField && event.key === 'Escape') {
            event.preventDefault();
        }
    }, [searchField]);
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsxs(cauldronReact.Button, { ref: anchorButtonRef, variant: "secondary", onClick: function () { return handleOpenChange(!isOpen); }, onKeyDown: handleKeyDown, "aria-haspopup": "dialog", children: [buttonLabel, " ", jsxRuntime.jsx(cauldronReact.Icon, { type: chevronType })] }), jsxRuntime.jsx(cauldronReact.ClickOutsideListener, { mouseEvent: !isOpen ? false : undefined, touchEvent: !isOpen ? false : undefined, onClickOutside: handleClickOutside, children: jsxRuntime.jsxs(cauldronReact.AnchoredOverlay, { ref: overlayRef, role: "dialog", "aria-label": overlayLabel, target: anchorButtonRef, className: modules_d6bb9f7a.issueFilter, open: isOpen, onOpenChange: handleOpenChange, placement: "bottom-start", offset: 3, focusTrap: true, focusTrapOptions: {
                        disabled: !isOpen,
                        returnFocus: true
                    }, style: { display: isOpen ? undefined : 'none' }, children: [searchField && (jsxRuntime.jsx("div", { className: modules_d6bb9f7a.search, children: jsxRuntime.jsx(cauldronReact.SearchField, __assign({ autoComplete: "off" }, searchFieldProps, { onKeyUpCapture: handleSearchKeyUp, placeholder: "" })) })), jsxRuntime.jsx("div", { className: modules_d6bb9f7a.filters, children: children }), jsxRuntime.jsxs("div", { className: modules_d6bb9f7a.actions, children: [jsxRuntime.jsx(cauldronReact.Button, { variant: "secondary", onClick: onClearAllFilters, disabled: selectedIssuesCount === null, children: t('Clear filters') }), jsxRuntime.jsx(cauldronReact.Button, { variant: "primary", onClick: onShowResults, children: selectedIssuesCount
                                        ? selectedIssuesCount === 1
                                            ? t('Show 1 result')
                                            : t('Show {{ resultCount, number }} results', {
                                                resultCount: selectedIssuesCount
                                            })
                                        : t('Show all results') })] })] }) })] }));
}

function IssueFilterItem(_a) {
    var children = _a.children, value = _a.value, description = _a.description, props = __rest(_a, ["children", "value", "description"]);
    var listboxOptionRef = React.useRef();
    var _b = __read(React.useState(false), 2), active = _b[0], setActive = _b[1];
    var _c = __read(React.useState(false), 2), selected = _c[0], setSelected = _c[1];
    React.useEffect(function () {
        if (!listboxOptionRef.current) {
            return;
        }
        var handleMutation = function (_a) {
            var _b = __read(_a, 1), mutation = _b[0];
            var target = mutation.target;
            var isActive = target.classList.contains(modules_d6bb9f7a.activeFilter);
            var isSelected = target.getAttribute('aria-selected') === 'true';
            setActive(isActive);
            setSelected(isSelected);
        };
        var observer = new MutationObserver(handleMutation);
        observer.observe(listboxOptionRef.current, {
            attributes: true,
            attributeFilter: ['aria-selected', 'class']
        });
        return function () {
            observer.disconnect();
        };
    }, []);
    React.useLayoutEffect(function () {
        var _a;
        if (active && listboxOptionRef.current) {
            // ensure this option stays within view when the options list
            // is inside of a scrollable container
            var rect = listboxOptionRef.current.getBoundingClientRect();
            /* c8 ignore next */
            (_a = listboxOptionRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                inline: 'nearest',
                /* c8 ignore next */
                block: rect.top <= 0 ? 'end' : 'nearest'
            });
        }
    }, [active]);
    return (jsxRuntime.jsxs(cauldronReact.ListboxOption, __assign({ ref: listboxOptionRef, activeClass: modules_d6bb9f7a.activeFilter, value: value }, props, { children: [jsxRuntime.jsx(cauldronReact.Icon, { type: selected ? 'checkbox-checked' : 'checkbox-unchecked' }), jsxRuntime.jsxs("span", { className: modules_d6bb9f7a.issueFilterItem, children: [children, description && (jsxRuntime.jsx("span", { className: modules_d6bb9f7a.issueFilterItemDescription, children: description }))] })] })));
}

/**
 * useFilterItems will perform an aggregate count for each unique value
 * for an individual property within a collection of issues and return a
 * collection of objects to provide filterable display values for that property.
 */
function useFilterItems(_a) {
    var property = _a.property, issues = _a.issues, label = _a.label;
    var _b = __read(React.useState([]), 2), selectedValues = _b[0], setSelectedValues = _b[1];
    var filterItems = React.useMemo(function () {
        var e_1, _a;
        var issuePropertyCountMap = new Map();
        var filterLabelFallback = function (issue) { return issue[property]; };
        try {
            for (var issues_1 = __values(issues), issues_1_1 = issues_1.next(); !issues_1_1.done; issues_1_1 = issues_1.next()) {
                var issue = issues_1_1.value;
                var issuePropertyValue = issue[property];
                if (!issuePropertyCountMap.has(issuePropertyValue)) {
                    issuePropertyCountMap.set(issuePropertyValue, {
                        count: 1,
                        label: typeof label === 'function'
                            ? label(issue)
                            : filterLabelFallback(issue),
                        value: issuePropertyValue
                    });
                }
                else {
                    // the property has been verified above via map.has
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var filterCount = issuePropertyCountMap.get(issuePropertyValue);
                    issuePropertyCountMap.set(issuePropertyValue, __assign(__assign({}, filterCount), { count: filterCount.count + 1 }));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (issues_1_1 && !issues_1_1.done && (_a = issues_1.return)) _a.call(issues_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return issuePropertyCountMap;
    }, [issues]);
    var onSelectionChange = React.useCallback(function (_a) {
        var value = _a.value;
        setSelectedValues(value);
    }, [filterItems]);
    var clearSelections = React.useCallback(function () {
        setSelectedValues([]);
    }, []);
    var totalSelectionCount = React.useMemo(function () {
        return selectedValues.reduce(function (count, selectedValue) {
            var _a;
            // if for some reason the filter items is not included, default to 0
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return count + ((_a = filterItems.get(selectedValue).count) !== null && _a !== void 0 ? _a : 0);
        }, 0);
    }, [selectedValues, filterItems]);
    return {
        filterItems: Array.from(filterItems.values()),
        selectedFilterValues: selectedValues,
        selectedIssuesCount: selectedValues.length === 0 ? null : totalSelectionCount,
        onSelectionChange: onSelectionChange,
        clearSelections: clearSelections
    };
}

function RuleIssueFilter(_a) {
    var issues = _a.issues, filter = _a.filter, onFilterChange = _a.onFilterChange;
    var t = useTranslation().t;
    var _b = __read(React.useState(false), 2), open = _b[0], setOpen = _b[1];
    var _c = __read(React.useState(''), 2), searchValue = _c[0], setSearchValue = _c[1];
    var initialFilterValues = React.useRef([]);
    var _d = __read(React.useState(t('Rule')), 2), buttonLabel = _d[0], setButtonLabel = _d[1];
    var _e = useFilterItems({
        property: 'ruleId',
        issues: issues,
        label: function (_a) {
            var ruleId = _a.ruleId, ruleName = _a.ruleName, help = _a.help;
            return ruleName || help || ruleId;
        }
    }), filterItems = _e.filterItems, selectedFilterValues = _e.selectedFilterValues, selectedIssuesCount = _e.selectedIssuesCount, onSelectionChange = _e.onSelectionChange, clearSelections = _e.clearSelections;
    var listboxId = "filter-listbox-".concat(utils.useId());
    var isControlled = typeof filter !== 'undefined';
    var ruleFilterItems = React.useMemo(function () {
        // order alphanumerically by the label of the rule
        return filterItems.sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [filterItems]);
    var matchingItemsFilter = React.useCallback(function (_a) {
        var label = _a.label;
        return label.toLowerCase().includes(searchValue.toLowerCase());
    }, [ruleFilterItems, searchValue]);
    var handleOpenChange = React.useCallback(function (isOpen) {
        if (!open && !isControlled) {
            // Reset the selections back to the initial selections if the
            // user did not commit the selected filters
            onSelectionChange({ value: initialFilterValues.current });
        }
        setOpen(isOpen);
    }, [initialFilterValues.current, isControlled]);
    var handleShowResults = React.useCallback(function () {
        if (typeof onFilterChange === 'function') {
            initialFilterValues.current = selectedFilterValues;
            onFilterChange(selectedFilterValues.length
                ? {
                    ruleId: selectedFilterValues
                }
                : null);
        }
        setButtonLabel(selectedFilterValues.length
            ? t("Rule ({{ ruleCount }})", {
                ruleCount: selectedFilterValues.length
            })
            : t('Rule'));
        setOpen(false);
    }, [onFilterChange, selectedFilterValues]);
    var renderFilterItem = React.useCallback(function (_a) {
        var value = _a.value, label = _a.label, count = _a.count;
        return (jsxRuntime.jsxs(IssueFilterItem, { value: value, children: [label, " (", count, ")"] }, value));
    }, []);
    React.useEffect(function () {
        if (!open) {
            setSearchValue('');
        }
    }, [open]);
    var matchingRuleFilterItems = searchValue.length
        ? ruleFilterItems.filter(matchingItemsFilter).map(renderFilterItem)
        : ruleFilterItems.map(renderFilterItem);
    return (jsxRuntime.jsx(IssueFilter, { open: open, buttonLabel: buttonLabel, overlayLabel: t('Rule Filters'), selectedIssuesCount: selectedIssuesCount, onClearAllFilters: clearSelections, onShowResults: handleShowResults, onOpenChange: handleOpenChange, searchField: true, searchFieldProps: {
            'aria-controls': listboxId,
            'aria-invalid': searchValue.length && !matchingRuleFilterItems.length
                ? true
                : undefined,
            label: t('Search by rule'),
            value: searchValue,
            onChange: setSearchValue,
            trailingChildren: searchValue.length ? (jsxRuntime.jsx("span", { className: modules_d6bb9f7a.searchFieldCounter, children: t("{{ count }} of {{ total }}", {
                    count: matchingRuleFilterItems.length,
                    total: ruleFilterItems.length
                }) })) : null
        }, children: !matchingRuleFilterItems.length ? (jsxRuntime.jsx("div", { className: modules_d6bb9f7a.emptyState, "aria-live": "polite", children: t('No results found for "{{ searchValue }}". Try another search.', {
                searchValue: searchValue
            }) })) : (jsxRuntime.jsx(cauldronReact.Listbox, { id: listboxId, "aria-label": t('Rules'), onSelectionChange: onSelectionChange, value: selectedFilterValues, multiselect: true, children: matchingRuleFilterItems })) }));
}

// Impact levels are displayed in order of severity with highest first
var ImpactLevels = [
    'critical',
    'serious',
    'moderate',
    'minor'
];
function ImpactIssueFilter(_a) {
    var issues = _a.issues, filter = _a.filter, onFilterChange = _a.onFilterChange;
    var t = useTranslation().t;
    var _b = __read(React.useState(false), 2), open = _b[0], setOpen = _b[1];
    var initialFilterValues = React.useRef([]);
    var _c = __read(React.useState(t('Impact')), 2), buttonLabel = _c[0], setButtonLabel = _c[1];
    var _d = useFilterItems({
        property: 'impact',
        // only include issues that have a set impact
        issues: issues.filter(function (issue) { return !!issue.impact; })
    }), 
    /* c8 ignore next */
    _e = _d.filterItems, 
    /* c8 ignore next */
    filterItems = _e === void 0 ? [] : _e, selectedFilterValues = _d.selectedFilterValues, selectedIssuesCount = _d.selectedIssuesCount, onSelectionChange = _d.onSelectionChange, clearSelections = _d.clearSelections;
    var listboxId = "filter-listbox-".concat(utils.useId());
    var isControlled = typeof filter !== 'undefined';
    var impactTranslations = React.useMemo(function () { return ({
        critical: t('Critical'),
        serious: t('Serious'),
        moderate: t('Moderate'),
        minor: t('Minor')
    }); }, [t]);
    var impactCount = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return ({
            critical: (_b = (_a = filterItems.find(function (filterItem) { return filterItem.value === 'critical'; })) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0,
            serious: (_d = (_c = filterItems.find(function (filterItem) { return filterItem.value === 'serious'; })) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : 0,
            moderate: (_f = (_e = filterItems.find(function (filterItem) { return filterItem.value === 'moderate'; })) === null || _e === void 0 ? void 0 : _e.count) !== null && _f !== void 0 ? _f : 0,
            minor: (_h = (_g = filterItems.find(function (filterItem) { return filterItem.value === 'minor'; })) === null || _g === void 0 ? void 0 : _g.count) !== null && _h !== void 0 ? _h : 0
        });
    }, [filterItems]);
    var handleOpenChange = React.useCallback(function (isOpen) {
        if (!open && !isControlled) {
            // Reset the selections back to the initial selections if the
            // user did not commit the selected filters
            onSelectionChange({ value: initialFilterValues.current });
        }
        setOpen(isOpen);
    }, [initialFilterValues.current, isControlled]);
    var handleShowResults = React.useCallback(function () {
        if (typeof onFilterChange === 'function') {
            initialFilterValues.current = selectedFilterValues;
            onFilterChange(selectedFilterValues.length
                ? {
                    impact: selectedFilterValues
                }
                : null);
        }
        setButtonLabel(selectedFilterValues.length
            ? t("Impact ({{ impactCount }})", {
                impactCount: selectedFilterValues.length
            })
            : t('Impact'));
        setOpen(false);
    }, [onFilterChange, selectedFilterValues]);
    return (jsxRuntime.jsx(IssueFilter, { open: open, buttonLabel: buttonLabel, overlayLabel: t('Impact Filters'), selectedIssuesCount: selectedIssuesCount, onClearAllFilters: clearSelections, onShowResults: handleShowResults, onOpenChange: handleOpenChange, children: jsxRuntime.jsx(cauldronReact.Listbox, { id: listboxId, "aria-label": t('Impacts'), onSelectionChange: onSelectionChange, value: selectedFilterValues, multiselect: true, children: ImpactLevels.map(function (impact) { return (jsxRuntime.jsxs(IssueFilterItem, { value: impact, children: [impactTranslations[impact], " (", impactCount[impact], ")"] }, impact)); }) }) }));
}

var CriteriaFilter = React__default.default.forwardRef(function (_a, ref) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (jsxRuntime.jsxs(cauldronReact.Button, { ref: ref, variant: "secondary", onClick: onClick, children: [t('WCAG'), jsxRuntime.jsx(cauldronReact.Icon, { type: "triangle-down" })] }));
});
CriteriaFilter.displayName = 'CriteriaFilter';

/**
 * generateHash is used to generate a hash which is used as a key in the filter Items
 */
var generateHash = function (filterProperties) { return __awaiter(void 0, void 0, void 0, function () {
    var encoder, data, hashBuffer, hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encoder = new TextEncoder();
                data = encoder.encode(JSON.stringify(filterProperties));
                return [4 /*yield*/, crypto.subtle.digest('SHA-256', data)];
            case 1:
                hashBuffer = _a.sent();
                hash = __spreadArray([], __read(new Uint8Array(hashBuffer)), false).map(function (byte) { return byte.toString(16); })
                    .join('');
                return [2 /*return*/, hash];
        }
    });
}); };

function useMultipleFilterProps(_a) {
    var _this = this;
    var properties = _a.properties, issues = _a.issues, key = _a.key, label = _a.label, description = _a.description;
    var _b = __read(React__default.default.useState([]), 2), selectedFilterValues = _b[0], setSelectedFilterValues = _b[1];
    var _c = __read(React__default.default.useState(new Map()), 2), filterItemsWithMap = _c[0], setFilterItemsWithMap = _c[1];
    React.useEffect(function () {
        var computeMap = function () { return __awaiter(_this, void 0, void 0, function () {
            var issuePropertyCountMap;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        issuePropertyCountMap = new Map();
                        return [4 /*yield*/, Promise.all(issues.map(function (issue) { return __awaiter(_this, void 0, void 0, function () {
                                var value, mapKey, existingItem;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            value = properties.reduce(function (acc, prop) {
                                                //'prop' is a key of T, and since T extends Issue prop is guaranteed to be a key of Issue  Therefore, it's safe to index the issue object using 'prop'
                                                acc[prop] = issue[prop];
                                                return acc;
                                            }, {});
                                            return [4 /*yield*/, key(value)];
                                        case 1:
                                            mapKey = _a.sent();
                                            if (!issuePropertyCountMap.has(mapKey)) {
                                                issuePropertyCountMap.set(mapKey, {
                                                    count: 1,
                                                    value: value,
                                                    key: mapKey,
                                                    label: label(issue),
                                                    description: description ? description(issue) : null
                                                });
                                            }
                                            else {
                                                existingItem = issuePropertyCountMap.get(mapKey);
                                                issuePropertyCountMap.set(mapKey, __assign(__assign({}, existingItem), { count: existingItem.count + 1 }));
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        setFilterItemsWithMap(issuePropertyCountMap);
                        return [2 /*return*/];
                }
            });
        }); };
        computeMap();
    }, [issues]);
    var onSelectionChange = React.useCallback(function (_a) {
        var value = _a.value;
        setSelectedFilterValues(value);
    }, [filterItemsWithMap]);
    var clearSelections = React.useCallback(function () {
        setSelectedFilterValues([]);
    }, []);
    var selectedIssuesCount = React.useMemo(function () {
        return selectedFilterValues.reduce(function (count, selectedItem) {
            var _a;
            // if for some reason the filter items is not included, default to 0
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return count + ((_a = filterItemsWithMap.get(selectedItem).count) !== null && _a !== void 0 ? _a : 0);
        }, 0);
    }, [selectedFilterValues, filterItemsWithMap]);
    return {
        selectedFilterValues: selectedFilterValues,
        onSelectionChange: onSelectionChange,
        clearSelections: clearSelections,
        filterItems: Array.from(filterItemsWithMap.values()),
        selectedIssuesCount: selectedIssuesCount == 0 ? null : selectedIssuesCount
    };
}

var PageTitleURLFilter = function (_a) {
    var issues = _a.issues, filter = _a.filter, onFilterChange = _a.onFilterChange;
    var t = useTranslation().t;
    var _b = __read(React.useState(false), 2), open = _b[0], setOpen = _b[1];
    var _c = __read(React.useState(t('Page title and URL')), 2), buttonLabel = _c[0], setButtonLabel = _c[1];
    var _d = __read(React.useState(''), 2), searchValue = _d[0], setSearchValue = _d[1];
    var initialFilterValues = React.useRef([]);
    var _e = useMultipleFilterProps({
        properties: ['testPageTitle', 'testUrl'],
        issues: issues,
        key: function (filterOption) { return generateHash(filterOption); },
        label: function (issue) { return issue.testPageTitle; },
        description: function (issue) { return issue.testUrl; }
    }), _f = _e.filterItems, filterItems = _f === void 0 ? [] : _f, //contains the list of unique pageTitle & URL with label, count & value for the node
    selectedFilterValues = _e.selectedFilterValues, // contains the selected list of pageTitle & URL node values
    selectedIssuesCount = _e.selectedIssuesCount, onSelectionChange = _e.onSelectionChange, clearSelections = _e.clearSelections;
    var listboxId = "filter-listbox-".concat(utils.useId());
    var isControlled = typeof filter !== 'undefined';
    var pageTitleUrlFilterItems = React.useMemo(function () {
        // order alphanumerically only by the first property value sent to the useFilterItems hooks
        return filterItems.sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [filterItems]);
    var matchingFilterItems = React.useMemo(function () {
        return pageTitleUrlFilterItems.filter(function (_a // value contains pageTitle & URL
        ) {
            var value = _a.value;
            return Object.values(value)
                .join('')
                .toLowerCase()
                .includes(searchValue.toLowerCase());
        });
    }, [pageTitleUrlFilterItems, searchValue]);
    var handleOpenChange = React.useCallback(function (isOpen) {
        if (!open && !isControlled) {
            /* Reset the selections back to the initial selections if the
              user did not commit the selected filters and filter is not controlled
            */
            onSelectionChange({ value: initialFilterValues.current });
        }
        setOpen(isOpen);
    }, [initialFilterValues.current, isControlled]);
    var handleShowResults = React.useCallback(function () {
        initialFilterValues.current = selectedFilterValues;
        var selectedFilters = filterItems.reduce(function (acc, filterItem) {
            if (selectedFilterValues.includes(filterItem.key)) {
                acc.push(filterItem.value);
            }
            return acc;
        }, []);
        if (typeof onFilterChange === 'function') {
            onFilterChange(selectedFilters);
        }
        setButtonLabel(selectedFilterValues.length
            ? t("Page title and URL ({{ pageUrlCount }})", {
                pageUrlCount: selectedIssuesCount
            })
            : t('Page title and URL'));
        setOpen(false);
        setSearchValue('');
    }, [onFilterChange, selectedFilterValues]);
    var itemsToShow = searchValue.length
        ? matchingFilterItems
        : pageTitleUrlFilterItems;
    var nodesToRender = itemsToShow.map(function (_a) {
        var key = _a.key, label = _a.label, count = _a.count, description = _a.description;
        return (jsxRuntime.jsxs(IssueFilterItem, { value: key, description: description !== null && description !== void 0 ? description : undefined, children: [label, " (", count, ")"] }, key));
    });
    var contentToDisplay = searchValue.length && !nodesToRender.length ? (jsxRuntime.jsx("div", { className: modules_d6bb9f7a.emptyState, "aria-live": "polite", children: t('No results found for "{{ searchValue }}". Try another search.', {
            searchValue: searchValue
        }) })) : (nodesToRender);
    return (jsxRuntime.jsx(IssueFilter, { open: open, buttonLabel: buttonLabel, overlayLabel: t('Page title and URL Filter'), selectedIssuesCount: selectedIssuesCount, onClearAllFilters: clearSelections, onShowResults: handleShowResults, onOpenChange: handleOpenChange, searchField: true, searchFieldProps: {
            'aria-controls': listboxId,
            'aria-invalid': searchValue.length && !matchingFilterItems.length ? true : undefined,
            label: t('Search by page title and URL'),
            value: searchValue,
            onChange: setSearchValue,
            trailingChildren: searchValue.length ? (jsxRuntime.jsx("span", { className: modules_d6bb9f7a.searchFieldCounter, children: t("{{ count }} of {{ total }}", {
                    count: matchingFilterItems.length,
                    total: filterItems.length
                }) })) : null
        }, children: jsxRuntime.jsx(cauldronReact.Listbox, { id: listboxId, "aria-label": t('Page title and URL Filter'), onSelectionChange: onSelectionChange, value: selectedFilterValues, multiselect: true, children: contentToDisplay }) }));
};
PageTitleURLFilter.displayName = 'PageTitleURLFilter';

function ScreenTitleIssueFilter(_a) {
    var issues = _a.issues, filter = _a.filter, onFilterChange = _a.onFilterChange;
    var t = useTranslation().t;
    var _b = __read(React.useState(false), 2), open = _b[0], setOpen = _b[1];
    var _c = __read(React.useState(''), 2), searchValue = _c[0], setSearchValue = _c[1];
    var initialFilterValues = React.useRef([]);
    var _d = __read(React.useState(t('Screen title')), 2), buttonLabel = _d[0], setButtonLabel = _d[1];
    var _e = useFilterItems({
        property: 'screenTitle',
        issues: issues
    }), filterItems = _e.filterItems, selectedFilterValues = _e.selectedFilterValues, selectedIssuesCount = _e.selectedIssuesCount, onSelectionChange = _e.onSelectionChange, clearSelections = _e.clearSelections;
    var listboxId = "filter-listbox-".concat(utils.useId());
    var isControlled = typeof filter !== 'undefined';
    var screenTitleFilterItems = React.useMemo(function () {
        return filterItems.sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [filterItems]);
    var matchingItemsFilter = React.useCallback(function (_a) {
        var label = _a.label;
        return label.toLowerCase().includes(searchValue.toLowerCase());
    }, [searchValue]);
    var handleOpenChange = React.useCallback(function (isOpen) {
        if (!open && !isControlled) {
            onSelectionChange({ value: initialFilterValues.current });
        }
        setOpen(isOpen);
    }, [initialFilterValues.current, isControlled]);
    var handleShowResults = React.useCallback(function () {
        if (typeof onFilterChange === 'function') {
            initialFilterValues.current = selectedFilterValues.filter(function (value) { return value !== undefined; });
            onFilterChange(selectedFilterValues.length
                ? {
                    screenTitle: selectedFilterValues
                }
                : null);
        }
        setButtonLabel(selectedFilterValues.length
            ? t("Screen title ({{ count }})", {
                count: selectedFilterValues.length
            })
            : t('Screen title'));
        setOpen(false);
    }, [onFilterChange, selectedFilterValues]);
    var renderFilterItem = React.useCallback(function (_a) {
        var value = _a.value, label = _a.label, count = _a.count;
        return (jsxRuntime.jsxs(IssueFilterItem, { value: value, children: [label, " (", count, ")"] }, value));
    }, []);
    React.useEffect(function () {
        if (!open) {
            setSearchValue('');
        }
    }, [open]);
    var matchingScreenTitleFilterItems = searchValue.length
        ? screenTitleFilterItems.filter(matchingItemsFilter).map(renderFilterItem)
        : screenTitleFilterItems.map(renderFilterItem);
    return (jsxRuntime.jsx(IssueFilter, { open: open, buttonLabel: buttonLabel, overlayLabel: t('Screen title Filters'), selectedIssuesCount: selectedIssuesCount, onClearAllFilters: clearSelections, onShowResults: handleShowResults, onOpenChange: handleOpenChange, searchField: true, searchFieldProps: {
            'aria-controls': listboxId,
            'aria-invalid': searchValue.length && !matchingScreenTitleFilterItems.length
                ? true
                : undefined,
            label: t('Search by screen title'),
            value: searchValue,
            onChange: setSearchValue,
            trailingChildren: searchValue.length ? (jsxRuntime.jsx("span", { className: modules_d6bb9f7a.searchFieldCounter, children: t("{{ count }} of {{ total }}", {
                    count: matchingScreenTitleFilterItems.length,
                    total: screenTitleFilterItems.length
                }) })) : null
        }, children: !matchingScreenTitleFilterItems.length ? (jsxRuntime.jsx("div", { className: modules_d6bb9f7a.emptyState, "aria-live": "polite", children: t('No results found for "{{ searchValue }}". Try another search.', {
                searchValue: searchValue
            }) })) : (jsxRuntime.jsx(cauldronReact.Listbox, { id: listboxId, "aria-label": t('Screen Titles'), onSelectionChange: onSelectionChange, value: selectedFilterValues, multiselect: true, children: matchingScreenTitleFilterItems })) }));
}

var modules_54a334e8 = {"container":"_container_1bcf8300"};

var Container = function (_a) {
    var issues = _a.issues;
    var onFilterChange = function () { };
    return (jsxRuntime.jsxs("div", { className: modules_54a334e8.container, children: [jsxRuntime.jsx(RuleIssueFilter, { issues: issues, onFilterChange: onFilterChange }), jsxRuntime.jsx(ImpactIssueFilter, { issues: issues, onFilterChange: onFilterChange }), jsxRuntime.jsx(CriteriaFilter, {}), jsxRuntime.jsx(PageTitleURLFilter, { issues: issues, onFilterChange: onFilterChange }), jsxRuntime.jsx(ScreenTitleIssueFilter, { issues: issues, onFilterChange: onFilterChange })] }));
};

/**
 * getIssueDiscoveryMethod is used to get the discovery method of an issue
 * @param issue - The issue object
 * @param t - The translation function
 * @returns The discovery method of the issue
 */
var getIssueDiscoveryMethod = function (issue, t) {
    if (issue.isManual) {
        return t('Manual');
    }
    if (issue.igt) {
        return "".concat(issue.igt, " IGT");
    }
    return t('Automatic');
};

var ImpactDataCell = function (_a) {
    var issue = _a.issue;
    return issue.impact ? (jsxRuntime.jsx(cauldronReact.ImpactBadge, { type: issue.impact, label: jsxRuntime.jsx(ImpactBadgeLabel, { type: issue.impact, hideLabel: true }) })) : null;
};

var TIME_FORMAT = 'hh:mm:ss aa';
var DATE_FORMAT = 'MMM dd, yyyy';
var DATE_TIME_FORMAT = "".concat(DATE_FORMAT, " (").concat(TIME_FORMAT, ")");
var DateTimeDataCell = function (_a) {
    var issue = _a.issue;
    var t = useTranslation().t;
    var isToday = issue.createdAt && dateFns.isToday(issue.createdAt);
    var isYesterday = issue.createdAt && dateFns.isYesterday(issue.createdAt);
    var isRelative = !!isToday || !!isYesterday;
    var formattedDate = issue.createdAt
        ? dateFns.format(issue.createdAt, DATE_TIME_FORMAT)
        : null;
    var relativeDate = isRelative && issue.createdAt
        ? "".concat(isToday ? t('Today') : t('Yesterday'), " (").concat(dateFns.format(issue.createdAt, TIME_FORMAT), ")")
        : null;
    return formattedDate ? (jsxRuntime.jsx("time", { dateTime: formattedDate, children: isRelative ? relativeDate : formattedDate })) : null;
};

var modules_cfd1b1a9 = {"pageTitle":"_pageTitle_3ee69462","pageUrl":"_pageUrl_3ee69462"};

var PageInfoDataCell = function (_a) {
    var issue = _a.issue;
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [issue.testPageTitle && (jsxRuntime.jsx("div", { className: modules_cfd1b1a9.pageTitle, children: issue.testPageTitle })), issue.testUrl && jsxRuntime.jsx("div", { className: modules_cfd1b1a9.pageUrl, children: issue.testUrl })] }));
};

var RuleDataCell = function (_a) {
    var issue = _a.issue, options = _a.options;
    var t = useTranslation().t;
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [options.renderLink ? (jsxRuntime.jsx(cauldronReact.Link, { href: issue.href, children: issue.help })) : (jsxRuntime.jsx("div", { children: issue.help })), issue.isExperimental && jsxRuntime.jsx(cauldronReact.Badge, { children: t('Experimental') })] }));
};

var modules_368e0595 = {"screenTitle":"_screenTitle_31a5547f"};

var ScreenTitleDataCell = function (_a) {
    var issue = _a.issue;
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: issue.screenTitle ? (jsxRuntime.jsx("span", { className: modules_368e0595.screenTitle, children: issue.screenTitle })) : null }));
};

var modules_58b1fda2 = {"CriteriaList":"_CriteriaList_f048979b","CriteriaListStacked":"_CriteriaListStacked_f048979b"};

var useGroupedCheckpoints = function (checkpoints, standards) {
    return React.useMemo(function () {
        var getFirstAvailableCheckpoint = function () {
            var wcagCheckpoints = checkpoints.filter(isWCAGCheckpointTagInfo);
            if (wcagCheckpoints.length > 0) {
                return {
                    selectedCheckpoints: wcagCheckpoints.slice(0, 1),
                    hidden: 0
                };
            }
            var groupedByType = checkpoints.reduce(function (acc, cp) {
                var type = cp.standardInfo.type;
                if (!acc[type]) {
                    acc[type] = [];
                }
                acc[type].push(cp);
                return acc;
            }, {});
            var standardTypes = Object.keys(groupedByType);
            if (standardTypes.length === 0) {
                return { selectedCheckpoints: [], hidden: 0 };
            }
            var firstStandard = groupedByType[standardTypes[0]][0];
            return {
                selectedCheckpoints: [firstStandard],
                hidden: Math.max(0, standardTypes.length - 1)
            };
        };
        var getSelectedCheckpoints = function () {
            var selectedCheckpoints = standards.reduce(function (acc, standard) {
                // Skip if we already have a WCAG checkpoint and current standard is WCAG-related
                var hasWcagCheckpoint = acc.some(function (checkpoint) { return checkpoint.standard === 'WCAG'; });
                if (hasWcagCheckpoint && standard.toLowerCase().startsWith('wcag')) {
                    return acc;
                }
                var firstMatch = checkpoints.find(function (checkpoint) {
                    if (standard.toLowerCase().startsWith('wcag')) {
                        return checkpoint.standard === 'WCAG';
                    }
                    return (checkpoint.standardInfo.type === checkpoint.standard &&
                        checkpoint.standardInfo.tags.includes(standard));
                });
                if (firstMatch) {
                    acc.push(firstMatch);
                }
                return acc;
            }, []);
            return {
                selectedCheckpoints: selectedCheckpoints,
                hidden: Math.max(0, checkpoints.length - selectedCheckpoints.length)
            };
        };
        if (!standards.length || standards.includes('all')) {
            var result_1 = getFirstAvailableCheckpoint();
            return [result_1.selectedCheckpoints, result_1.hidden];
        }
        var result = getSelectedCheckpoints();
        return [result.selectedCheckpoints, result.hidden];
    }, [checkpoints, standards]);
};
var CriteriaToDisplay = function (_a) {
    var _b;
    var checkpoints = _a.checkpoints, hiddenCount = _a.hiddenCount;
    if (!checkpoints.length) {
        return null;
    }
    return (jsxRuntime.jsxs("ul", { className: classnames__default.default(modules_58b1fda2.CriteriaList, (_b = {},
            _b[modules_58b1fda2.CriteriaListStacked] = checkpoints.length > 1,
            _b)), children: [checkpoints.map(function (checkpoint) { return (jsxRuntime.jsx("li", { children: jsxRuntime.jsx(SuccessCriteriaBadge, { ruleset: checkpoint.standardInfo, checkpoint: checkpoint }) }, checkpoint.value)); }), hiddenCount > 0 && (jsxRuntime.jsx("li", { children: jsxRuntime.jsxs(cauldronReact.Badge, { children: ["+", hiddenCount] }) }))] }));
};
var CriteriaDataCell = function (_a) {
    var issue = _a.issue, accessibilityStandard = _a.accessibilityStandard;
    var _b = issue.tags, tags = _b === void 0 ? [] : _b;
    var t = useTranslation().t;
    var checkpoints = useCheckpointsTagInfo(tags);
    var accessibilityStandards = useAccessibilityStandards(tags);
    var issueAccessibilityStandards = React.useMemo(function () {
        if (!accessibilityStandard ||
            (Array.isArray(accessibilityStandard) && !accessibilityStandard.length)) {
            return ['all'];
        }
        var standardArray = Array.isArray(accessibilityStandard)
            ? accessibilityStandard
            : [accessibilityStandard];
        return standardArray;
    }, [accessibilityStandard]);
    var checkpointWithStandards = React.useMemo(function () {
        return checkpoints.map(function (checkpoint) { return (__assign(__assign({}, checkpoint), { standardInfo: accessibilityStandards.find(function (s) { return s.type === checkpoint.standard; }) })); });
    }, [checkpoints, accessibilityStandards]);
    var _c = __read(useGroupedCheckpoints(checkpointWithStandards, issueAccessibilityStandards), 2), shownCheckpoints = _c[0], hiddenCount = _c[1];
    if (tags.includes('best-practice')) {
        return jsxRuntime.jsx(cauldronReact.Badge, { children: t('Deque Best Practice') });
    }
    return (jsxRuntime.jsx(CriteriaToDisplay, { checkpoints: shownCheckpoints, hiddenCount: hiddenCount }));
};

var AggregateCountDataCell = function (_a) {
    var _b;
    var issue = _a.issue, columnConfiguration = _a.columnConfiguration;
    return (jsxRuntime.jsx(jsxRuntime.Fragment, { children: (_b = issue[columnConfiguration.aggregateKey]) !== null && _b !== void 0 ? _b : 0 }));
};

var StatusDataCell = function (_a) {
    var _b;
    var issue = _a.issue;
    return (jsxRuntime.jsx("div", { children: (_b = issue.status) === null || _b === void 0 ? void 0 : _b.map(function (status, index) { return (jsxRuntime.jsx("p", { children: status }, "".concat(index, "-status"))); }) }));
};

var ElementSource = function (_a) {
    var issue = _a.issue;
    if (issue.source) {
        return (jsxRuntime.jsx(cauldronReact.TextEllipsis, { maxLines: 5, hideTooltip: true, children: issue.source }));
    }
    return null;
};

var DiscoveryMethodDataCell = function (_a) {
    var issue = _a.issue;
    var t = useTranslation().t;
    var discoveryMethod = getIssueDiscoveryMethod(issue, t);
    return jsxRuntime.jsx("span", { children: discoveryMethod });
};

var Columns = Object.freeze({
    /**
     * Displays a short description of the rule.
     */
    Rule: {
        type: Symbol('Rule'),
        align: 'start',
        width: 'auto',
        maxWidth: '432'
    },
    /**
     * Displays the impact level of the issue (if present).
     */
    Impact: {
        type: Symbol('Impact'),
        align: 'start',
        width: 'max-content'
    },
    /**
     * Displays the date and time of which the issue was found.
     */
    DateTime: {
        type: Symbol('DateTime'),
        align: 'start',
        width: 'max-content'
    },
    /**
     * Displays the page title and page url of the page of which the issue was found (if applicable).
     */
    PageInfo: {
        type: Symbol('PageInfo'),
        align: 'start',
        width: 'auto',
        maxWidth: '432'
    },
    /**
     * Displays the title of the scan that the issue was found on. Mobile product only.
     */
    ScreenTitle: {
        type: Symbol('ScreenTitle'),
        align: 'start',
        width: 'auto',
        maxWidth: '432'
    },
    /**
     * Displays the status of the issue.
     */
    Status: {
        type: Symbol('Status'),
        align: 'start',
        width: 'auto',
        maxWidth: '432'
    },
    /**
     * Displays the criteria the rule is associated with, inside the chosen standard.
     */
    Criteria: {
        type: Symbol('Criteria'),
        align: 'start',
        width: 'max-content'
    },
    ElementSource: {
        type: Symbol('ElementSource'),
        align: 'start',
        width: 'auto',
        maxWidth: '432'
    },
    /**
     * Displays discovery method of the issue.
     */
    DiscoveryMethod: {
        type: Symbol('DiscoveryMethod'),
        align: 'start',
        width: 'max-content',
        maxWidth: '432'
    }
});
/**
 *  A column that displays custom data cells for the provided header.
 */
var CustomColumn = Object.freeze({
    type: Symbol('Custom'),
    align: 'start',
    width: 'auto'
});
var AggregateColumns = Object.freeze({
    /**
     * Displays the aggregated count of issues when the data is grouped by a field or set of fields for a given issue.
     */
    IssueCount: {
        type: Symbol('IssueCount'),
        aggregateKey: 'aggregateIssueCount',
        align: 'end',
        width: 'max-content'
    },
    /**
     * Displays the aggregated count of critical issues when the data is grouped by a field or set of fields for a given issue.
     */
    CriticalIssueCount: {
        type: Symbol('CriticalIssueCount'),
        aggregateKey: 'aggregateCriticalIssueCount',
        align: 'end',
        width: 'max-content'
    },
    /**
     * Displays the aggregated count of new issues when the data is grouped by a field or set of fields for a given issue.
     */
    NewIssueCount: {
        type: Symbol('NewIssueCount'),
        aggregateKey: 'aggregateNewIssueCount',
        align: 'end',
        width: 'max-content'
    },
    /**
     * Displays the aggregated count of serious issues when the data is grouped by a field or set of fields for a given issue.
     */
    SeriousIssueCount: {
        type: Symbol('SeriousIssueCount'),
        aggregateKey: 'aggregateSeriousIssueCount',
        align: 'end',
        width: 'max-content'
    },
    /**
     * A column that displays a number representing an aggregated critical issue count
     */
    PageCount: {
        type: Symbol('PageCount'),
        aggregateKey: 'aggregatePageCount',
        align: 'end',
        width: 'max-content'
    }
});

function throwBadRenderDataCell(renderDataCellFunction) {
    throw new Error("Unsupported column type renderDataCell value: ".concat(renderDataCellFunction));
}
function hasValidRenderDataCell(columnConfiguration) {
    return typeof columnConfiguration.renderDataCell === 'function';
}
function isAggregateColumn(columnConfiguration) {
    return (typeof columnConfiguration
        .aggregateKey === 'string');
}
var getRequiredColumnConfiguration = function (columnConfiguration) {
    if (!hasValidRenderDataCell(columnConfiguration)) {
        var renderDataCellFunction = void 0;
        if (isAggregateColumn(columnConfiguration)) {
            renderDataCellFunction = function (_a) {
                var issue = _a.issue;
                return (jsxRuntime.jsx(AggregateCountDataCell, { issue: issue, columnConfiguration: columnConfiguration }));
            };
        }
        else {
            switch (columnConfiguration.type) {
                case Columns.Rule.type:
                    renderDataCellFunction = RuleDataCell;
                    break;
                case Columns.Impact.type:
                    renderDataCellFunction = ImpactDataCell;
                    break;
                case Columns.PageInfo.type:
                    renderDataCellFunction = PageInfoDataCell;
                    break;
                case Columns.DateTime.type:
                    renderDataCellFunction = DateTimeDataCell;
                    break;
                case Columns.ScreenTitle.type:
                    renderDataCellFunction = ScreenTitleDataCell;
                    break;
                case Columns.Status.type:
                    renderDataCellFunction = StatusDataCell;
                    break;
                case Columns.Criteria.type:
                    renderDataCellFunction = function (_a) {
                        var issue = _a.issue, accessibilityStandard = _a.options.accessibilityStandard;
                        return (jsxRuntime.jsx(CriteriaDataCell, { issue: issue, accessibilityStandard: accessibilityStandard }));
                    };
                    break;
                case Columns.ElementSource.type:
                    renderDataCellFunction = function (_a) {
                        var issue = _a.issue;
                        return (jsxRuntime.jsx(ElementSource, { issue: issue }));
                    };
                    break;
                case Columns.DiscoveryMethod.type:
                    renderDataCellFunction = DiscoveryMethodDataCell;
                    break;
                default:
                    throwBadRenderDataCell(columnConfiguration.renderDataCell);
            }
        }
        return __assign(__assign({}, columnConfiguration), { renderDataCell: renderDataCellFunction });
    }
    return columnConfiguration;
};
function renderColumnDataCell(columnConfiguration, issue, options) {
    var requiredColumnConfiguration = getRequiredColumnConfiguration(columnConfiguration);
    var DataCellComponent = requiredColumnConfiguration.renderDataCell;
    return jsxRuntime.jsx(DataCellComponent, { issue: issue, options: options });
}

var severityOrder = {
    critical: 1,
    serious: 2,
    moderate: 3,
    minor: 4
};
var compareNulls = function (valueA, valueB, sortDirection) {
    var isValueA = valueA !== null && valueA !== undefined;
    var isValueB = valueB !== null && valueB !== undefined;
    if (!isValueA && !isValueB) {
        return 0;
    }
    if (!isValueA) {
        return sortDirection === 'ascending' ? -1 : 1;
    }
    if (!isValueB) {
        return sortDirection === 'ascending' ? 1 : -1;
    }
    return null;
};
var sortByAlphaNumeric = function (sortDirection, property) {
    return function (a, b) {
        var issueA = a[property];
        var issueB = b[property];
        var nullComparison = compareNulls(issueA, issueB, sortDirection);
        if (nullComparison !== null) {
            return nullComparison;
        }
        /* c8 ignore next 2: we have no comparator, which uses this case */
        if (typeof issueA === 'number' && typeof issueB === 'number') {
            return sortDirection === 'ascending' ? issueA - issueB : issueB - issueA;
        }
        else if (typeof issueA === 'string' && typeof issueB === 'string') {
            var compareResult = issueA.localeCompare(issueB);
            return sortDirection === 'ascending' ? compareResult : -compareResult;
        }
        /* c8 ignore next: default fallback value */
        return 0;
    };
};
var sortByTimestamp = function (sortDirection, property) {
    return function (a, b) {
        var issueA = a[property];
        var issueB = b[property];
        var nullComparison = compareNulls(issueA, issueB, sortDirection);
        if (nullComparison !== null) {
            return nullComparison;
        }
        var timestampA = a[property];
        var timestampB = b[property];
        var timeA = typeof timestampA === 'string'
            ? new Date(timestampA).getTime()
            : Number(timestampA);
        var timeB = typeof timestampB === 'string'
            ? new Date(timestampB).getTime()
            : Number(timestampB);
        if (sortDirection === 'ascending') {
            return timeB - timeA;
        }
        else {
            return timeA - timeB;
        }
    };
};
var sortByImpact = function (sortDirection) { return function (a, b) {
    var nullComparison = compareNulls(a.impact, b.impact, sortDirection);
    if (nullComparison !== null) {
        return nullComparison;
    }
    var aImpact = a.impact;
    var bImpact = b.impact;
    return sortDirection === 'ascending'
        ? severityOrder[aImpact] - severityOrder[bImpact]
        : severityOrder[bImpact] - severityOrder[aImpact];
}; };
var sortByCriteria = function (sortDirection) {
    return function (a, b) {
        var issueA = a.wcagCheckpoints && a.wcagCheckpoints.length
            ? a.wcagCheckpoints[0].checkpoint
            : null;
        var issueB = b.wcagCheckpoints && b.wcagCheckpoints.length
            ? b.wcagCheckpoints[0].checkpoint
            : null;
        var nullComparison = compareNulls(issueA, issueB, sortDirection);
        if (nullComparison !== null) {
            return nullComparison;
        }
        var compareResult = issueA.localeCompare(issueB, undefined, { numeric: true });
        return sortDirection === 'ascending' ? compareResult : -compareResult;
    };
};
var sortAggregateCountByNumeric = function (sortDirection, columnType) {
    return function (a, b) {
        var _a, _b;
        var columnConfig = Object.values(AggregateColumns).find(function (col) { return col.type === columnType; });
        if (!columnConfig) {
            throw new Error("Unknown column type: ".concat(columnType.toString()));
        }
        var aggregateKey = columnConfig.aggregateKey;
        var valueA = (_a = a[aggregateKey]) !== null && _a !== void 0 ? _a : '';
        var valueB = (_b = b[aggregateKey]) !== null && _b !== void 0 ? _b : '';
        var nullComparison = compareNulls(valueA, valueB, sortDirection);
        if (nullComparison !== null) {
            return nullComparison;
        }
        return sortDirection === 'ascending' ? valueA - valueB : valueB - valueA;
    };
};
var sortByDiscoveryMethod = function (sortDirection, t) {
    return function (a, b) {
        var displayA = getIssueDiscoveryMethod(a, t);
        var displayB = getIssueDiscoveryMethod(b, t);
        var compareResult = displayA.localeCompare(displayB);
        return sortDirection === 'ascending' ? compareResult : -compareResult;
    };
};
function useSorter(issues) {
    var _a = __read(React.useState([null, 'none']), 2), sort = _a[0], setSort = _a[1];
    var t = useTranslation().t;
    var _b = __read(sort, 2), sortBy = _b[0], sortDirection = _b[1];
    var getComparator = React.useCallback(function (sortingBy, sortingDirection) {
        switch (sortingBy) {
            case Columns.Impact.type:
                return sortByImpact(sortingDirection);
            case Columns.PageInfo.type:
                return sortByAlphaNumeric(sortingDirection, 'testPageTitle');
            case Columns.ScreenTitle.type:
                return sortByAlphaNumeric(sortingDirection, 'screenTitle');
            case Columns.DateTime.type:
                return sortByTimestamp(sortingDirection, 'createdAt');
            case Columns.Rule.type:
                return sortByAlphaNumeric(sortingDirection, 'help');
            case Columns.Criteria.type:
                return sortByCriteria(sortingDirection);
            case Columns.Status.type:
                return sortByAlphaNumeric(sortingDirection, 'status');
            case Columns.DiscoveryMethod.type:
                return sortByDiscoveryMethod(sortingDirection, t);
            case AggregateColumns.IssueCount.type:
            case AggregateColumns.CriticalIssueCount.type:
            case AggregateColumns.NewIssueCount.type:
            case AggregateColumns.SeriousIssueCount.type:
            case AggregateColumns.PageCount.type:
                return sortAggregateCountByNumeric(sortingDirection, sortingBy);
            default:
                throw new Error("Unknown sort comparator function: ".concat(sortingBy.toString()));
        }
    }, [t]);
    var getCurrentSortDirection = function (column) {
        return column === sortBy ? sortDirection : 'none';
    };
    var getNextSortDirection = function (column) {
        return column === sortBy && sortDirection === 'ascending'
            ? 'descending'
            : 'ascending';
    };
    var sortedIssues = React.useMemo(function () {
        if (!sortBy) {
            return issues;
        }
        var ComparatorFunc = getComparator(sortBy, sortDirection);
        /* c8 ignore next 3 */
        if (!ComparatorFunc) {
            return issues;
        }
        return issues.sort(ComparatorFunc);
    }, [issues, sortBy, sortDirection]);
    return {
        sortedIssues: sortedIssues,
        updateSort: setSort,
        getCurrentSortDirection: getCurrentSortDirection,
        getNextSortDirection: getNextSortDirection
    };
}

var IssuesDataTable = function (_a) {
    var issues = _a.issues, columns = _a.columns, accessibilityStandard = _a.accessibilityStandard, className = _a.className, props = __rest(_a, ["issues", "columns", "accessibilityStandard", "className"]);
    var t = useTranslation().t;
    var issuesIdentifier = issues
        .map(function (issue) {
        if (issue.issueId) {
            return issue.issueId;
        }
        if ((issue.ruleId || issue.ruleName) && issue.selector) {
            return "".concat(issue.ruleId || issue.ruleName, "-").concat(issue.selector.join(','));
        }
    })
        .join(',');
    var issueWithWcagCheckpoints = React.useMemo(function () {
        return issues.map(function (issue) { return (__assign(__assign({}, issue), { wcagCheckpoints: getCheckpoints(issue.tags).filter(isWCAGCheckpointTagInfo) })); });
    }, [issuesIdentifier]);
    var _b = useSorter(issueWithWcagCheckpoints), sortedIssues = _b.sortedIssues, updateSort = _b.updateSort, getCurrentSortDirection = _b.getCurrentSortDirection, getNextSortDirection = _b.getNextSortDirection;
    var issueHasUrlAndTitle = issues.some(function (issue) { return issue.helpUrl && issue.testPageTitle; });
    var translatedDataColumnHeaders = React.useMemo(function () {
        var _a;
        return (_a = {},
            _a[Columns.Rule.type] = t('Rule'),
            _a[Columns.DateTime.type] = t('Date discovered'),
            _a[Columns.Impact.type] = t('Impact'),
            _a[Columns.PageInfo.type] = issueHasUrlAndTitle
                ? t('Page title and URL')
                : t('URL'),
            _a[Columns.ScreenTitle.type] = t('Screen title'),
            _a[Columns.Status.type] = t('Status'),
            _a[Columns.Criteria.type] = t('Criteria'),
            _a[Columns.ElementSource.type] = t('Element source'),
            _a[Columns.DiscoveryMethod.type] = t('Discovery method'),
            _a[AggregateColumns.IssueCount.type] = t('Issues'),
            _a[AggregateColumns.CriticalIssueCount.type] = t('Critical issues'),
            _a[AggregateColumns.NewIssueCount.type] = t('New issues'),
            _a[AggregateColumns.SeriousIssueCount.type] = t('Serious issues'),
            _a[AggregateColumns.PageCount.type] = t('Pages'),
            _a[CustomColumn.type] = t('Custom'),
            _a);
    }, [t, issueHasUrlAndTitle]);
    var gridColumns = columns.map(function (column) {
        var _a, _b, _c;
        return ({
            width: (_a = column.width) !== null && _a !== void 0 ? _a : 'auto',
            maxWidth: (_b = column.maxWidth) !== null && _b !== void 0 ? _b : 'auto',
            align: (_c = column.align) !== null && _c !== void 0 ? _c : 'start'
        });
    });
    return (jsxRuntime.jsxs(cauldronReact.Table, __assign({ className: classnames__default.default(className), layout: "grid", columns: gridColumns }, props, { children: [jsxRuntime.jsx(cauldronReact.TableHead, { children: jsxRuntime.jsx(cauldronReact.TableRow, { children: columns.length &&
                        columns.map(function (column) {
                            var _a;
                            return (jsxRuntime.jsx(cauldronReact.TableHeader, __assign({ scope: "col" }, (column.sortable
                                ? {
                                    sortDirection: getCurrentSortDirection(column.type),
                                    sortAscendingAnnouncement: t('{{headerName}} sorted ascending', {
                                        headerName: translatedDataColumnHeaders[column.type]
                                    }),
                                    sortDescendingAnnouncement: t('{{headerName}} sorted descending', {
                                        headerName: translatedDataColumnHeaders[column.type]
                                    }),
                                    onSort: function () {
                                        return updateSort([
                                            column.type,
                                            getNextSortDirection(column.type)
                                        ]);
                                    }
                                }
                                : {}), { children: (_a = column.header) !== null && _a !== void 0 ? _a : translatedDataColumnHeaders[column.type] }), column.type.toString()));
                        }) }) }), jsxRuntime.jsx(cauldronReact.TableBody, { children: sortedIssues.map(function (issue, rowIndex) { return (jsxRuntime.jsx(cauldronReact.TableRow, { children: columns.map(function (column, columnIndex) { return (jsxRuntime.jsx(cauldronReact.TableCell, { children: renderColumnDataCell(column, issue, {
                            renderLink: columnIndex === 0,
                            accessibilityStandard: accessibilityStandard
                        }) }, "".concat(issue.issueId || rowIndex, "-").concat(columnIndex))); }) }, issue.issueId || rowIndex)); }) })] })));
};
IssuesDataTable.displayName = 'IssuesDataTable';

var isObject = function (value) {
    return value !== null && typeof value === 'object';
};
var hasArrayIntersection = function (a, b) {
    if (a.length === 0 && b.length === 0) {
        return true;
    }
    var isObjectsArrayA = a.every(isObject);
    var isObjectsArrayB = b.every(isObject);
    if (isObjectsArrayB && isObjectsArrayA) {
        return b.some(function (value) {
            return a.some(function (v) {
                return hasObjectIntersection(value, v);
            });
        });
    }
    return a.some(function (value) { return b.includes(value); });
};
var isNonNullObject = function (a) { return a !== null && typeof a === 'object'; };
var hasObjectIntersection = function (a, b) {
    var isNonNullObjectA = isNonNullObject(a);
    var isNonNullObjectB = isNonNullObject(b);
    var isNullOrEmptyA = !isNonNullObjectA || Object.keys(a).length === 0;
    var isNullOrEmptyB = !isNonNullObjectB || Object.keys(b).length === 0;
    if (isNullOrEmptyA && isNullOrEmptyB) {
        return true;
    }
    var deepEqual = function (val1, val2) {
        if (val1 === val2) {
            return true;
        } // handles primitives, same reference or identical values
        // Handle if either value is an object or array (deep comparison)
        if (typeof val1 === 'object' &&
            val1 !== null &&
            typeof val2 === 'object' &&
            val2 !== null) {
            if (Array.isArray(val1) && Array.isArray(val2)) {
                // Arrays check
                return hasArrayIntersection(val1, val2);
            }
            // Object check
            if (!Array.isArray(val1) && !Array.isArray(val2)) {
                var keys1 = Object.keys(val1);
                var keys2_1 = Object.keys(val2);
                return keys1.some(function (key) {
                    return keys2_1.includes(key) &&
                        deepEqual(val1[key], val2[key]);
                });
            }
        }
        return false; // Return false if no match was found
    };
    return (isNonNullObjectA &&
        Object.entries(a).some(function (_a) {
            var _b = __read(_a, 2), keyA = _b[0], valueA = _b[1];
            // For each key-value pair in `a`, check if any matching key-value pair exists in `b`
            return isNonNullObjectB &&
                Object.entries(b).some(function (_a) {
                    var _b = __read(_a, 2), keyB = _b[0], valueB = _b[1];
                    return keyA === keyB && deepEqual(valueA, valueB);
                });
        }));
};

var useIssuesFilter = function (issues, initialIssuesFilters) {
    if (initialIssuesFilters === void 0) { initialIssuesFilters = {}; }
    var _a = __read(React.useState(initialIssuesFilters), 2), issuesFilter = _a[0], setIssuesFilters = _a[1];
    var filteredIssues = React.useMemo(function () {
        if (!issuesFilter || !Object.keys(issuesFilter).length) {
            return issues;
        }
        return issues.filter(function (issue) {
            return Object.entries(issuesFilter).some(function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                var issueProperty = issue[key];
                var filterValues = value;
                if (Array.isArray(issueProperty) &&
                    filterValues.every(function (filterValue) { return Array.isArray(filterValue); })) {
                    return filterValues.some(function (valuesArray) {
                        return valuesArray.length
                            ? hasArrayIntersection(issueProperty, valuesArray)
                            : false;
                    });
                }
                if (typeof issueProperty === 'object' &&
                    issueProperty !== null &&
                    !Array.isArray(issueProperty) &&
                    filterValues.every(function (filterValue) { return typeof filterValue === 'object'; })) {
                    return filterValues.some(function (filterValue) {
                        return filterValue &&
                            !Array.isArray(filterValue) &&
                            hasObjectIntersection(issueProperty, filterValue);
                    });
                }
                return issueProperty && filterValues.includes(issueProperty);
            });
        });
    }, [issuesFilter, issues]);
    var clearIssuesFilters = function () { return setIssuesFilters({}); };
    return {
        issues: filteredIssues,
        issuesFilter: issuesFilter,
        setIssuesFilters: setIssuesFilters,
        clearIssuesFilters: clearIssuesFilters
    };
};

exports.CriteriaFilter = CriteriaFilter;
exports.ImpactFilter = ImpactIssueFilter;
exports.Issue = Issue;
exports.IssueAggregateColumns = AggregateColumns;
exports.IssueColumns = Columns;
exports.IssueCustomColumn = CustomColumn;
exports.IssueDetails = IssueDetails;
exports.IssueFilters = Container;
exports.IssueHeader = IssueHeader;
exports.IssueMetadata = IssueMetadata;
exports.IssuePage = IssuePage;
exports.IssuesDataTable = IssuesDataTable;
exports.PageTitleURLFilter = PageTitleURLFilter;
exports.RuleDetails = RuleDetails;
exports.RuleFilter = RuleIssueFilter;
exports.ScreenTitleFilter = ScreenTitleIssueFilter;
exports.ScreenshotConfiguration = ScreenshotConfiguration;
exports.Trans = Trans;
exports.configure = configure;
exports.getCheckpoints = getCheckpoints;
exports.i18n = instance;
exports.isWCAGCheckpointTagInfo = isWCAGCheckpointTagInfo;
exports.supportedLocales = supportedLocales;
exports.useAccessibilityStandards = useAccessibilityStandards;
exports.useAriaIsolation = useAriaIsolation;
exports.useCSSPropertyValue = useCSSPropertyValue;
exports.useCheckpointsTagInfo = useCheckpointsTagInfo;
exports.useIntersectionObserver = useIntersectionObserver;
exports.useIssuesFilter = useIssuesFilter;
exports.useResizeObserver = useResizeObserver;
exports.useSharedRef = useSharedRef;
exports.useTranslation = useTranslation;
exports.useWCAGCheckpointsTagInfo = useWCAGCheckpointsTagInfo;
exports.useWCAGStandard = useWCAGStandard;
